export interface Translations {
  // Step 1 - Nickname
  nickname: {
    title: string;
    subtitle: string;
    placeholder: string;
    checking: string;
    available: string;
    notAvailable: string;
    error: string;
    required: string;
    tooShort: string;
    tooLong: string;
    infoTitle: string;
    infoDescription: string;
  };

  // Step 2 - Category
  category: {
    title: string;
    subtitle: string;
    required: string;
    categories: {
      [key: string]: string;
    };
  };

  // Step 3 - Interests
  interests?: {
    title: string;
    subtitle: string;
    description?: string;
    required?: string;
  };

  // Step 4 - Age
  age: {
    title: string;
    subtitle: string;
    birthDate: string;
    partnerBirthDate: string;
    partnerBirthDateOptional: string;
    required: string;
    minimumAge: string;
    invalidAge: string;
    partnerMinimumAge: string;
    birthDateHim: string;
    birthDateHer: string;
    yourBirthDate: string;
    age: string;
    years: string;
    partnerAge: string;
    importantInfo: string;
    ageRequiredInfo: string;
  };

  // Step 5 - Location
  location: {
    title: string;
    subtitle: string;
    placeholder: string;
    required: string;
    incomplete: string;
    invalid: string;
    yourCity: string;
    searchPlaceholder: string;
    selectedLocation: string;
    coordinates: string;
    searchDescription: string;
    privacyTitle: string;
    privacyDescription: string;
    address: string;
    addressHelp: string;
    coordinatesHelp: string;
    addressVisibility: string;
    addressImmediately: string;
    maxHours: string;
    addressVisibilityHelp: string;
    locationAddress: string;
    streetAddress: string;
    openInGoogleMaps: string;
    addressWillBeRevealed: string;
    confirmedParticipantsOnly: string;
    now: string;
  };

  // Step 6 - Confirm
  confirm: {
    title: string;
    subtitle: string;
    nickname: string;
    category: string;
    age: string;
    location: string;
    partner: string;
    years: string;
    incomplete: string;
  };

  // PhotoManager2Onboarding
  photoOnboarding: {
    welcome: string;
    subtitle: string;
    uploadSuccess: string;
    photoManagement: string;
    guidelinesTitle: string;
    allowedContent: string;
    allowedErotic: string;
    allowedFace: string;
    allowedReal: string;
    prohibitedContent: string;
    prohibitedMinors: string;
    prohibitedNonConsensual: string;
    prohibitedViolence: string;
    prohibitedFake: string;
    prohibitedNonPersonal: string;
    warningTitle: string;
    warningText: string;
    startUsingApp: string;
  };

  // Validations
  validations: {
    title: string;
    exchangeValidation: string;
    validationsConfirmed: string;
    pending: string;
    noValidations: string;
    noValidationsDescription: string;
    sendValidation: string;
    validationSentSuccess: string;
    validationSendError: string;
    accept: string;
    decline: string;
    removeConfirm: string;
    sentByYou: string;
    confirmed: string;
    declined: string;
    waiting?: string;
    validation1Title: string;
    validation1Subtitle?: string;
    validation2Title: string;
    validation2Subtitle?: string;
    validation3Title: string;
    validation3Subtitle?: string;
    metInPerson: string;
    playedTogether: string;
    builtRelationship: string;
    validation1Description?: string;
    validation2Description?: string;
    validation3Description?: string;
    close?: string;
    remove?: string;
    confirmSendValidation?: string;
    confirmDeclineValidation?: string;
  };

  // Partner Linking
  partnerLinking: {
    title: string;
    connected: string;
    connectedDescription: string;
    notConnectedDescription: string;
    inputPlaceholder: string;
    buttonConnect: string;
    buttonSaving: string;
    helpText: string;
  };

  // Partner Modal
  partnerModal: {
    title: string;
    titleReadOnly: string;
    infoReadOnly: string;
    infoReadOnlyNotConnected: string;
    info: string;
    usernameLabel: string;
    saving: string;
    usernamePlaceholder: string;
    linkedStatus: string;
    linkedDescription: string;
    namesLabel: string;
    namesDescription: string;
    firstPartnerPlaceholder: string;
    secondPartnerPlaceholder: string;
    namesReadOnlyTitle: string;
    namesReadOnlyDescription: string;
    partnerLinked: string;
    addPartner: string;
  };

  // Common
  common: {
    continue: string;
    back: string;
    completeRegistration: string;
    loading: string;
    error: string;
    success: string;
    spots: string;
    day: string;
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
    participants: string;
    close: string;
    confirmed: string;
    showTicket: string;
    validations: string;
  };

  // Banned Account
  banned: {
    title: string;
    message: string;
    reason: string;
    defaultReason: string;
    permanentMessage: string;
    supportInfo: string;
  };

  // Speed dates
  speedDates: {
    today: string;
    tomorrow: string;
    dayAfterTomorrow: string;
    openTo: string;
  };

  // Chat
  chat?: {
    requestTitle: string;
    continueOnTelegram: string;
    privacyMessage: string;
    messageLabel: string;
    messagePlaceholder: string;
    decline: string;
    accept: string;
    noChatsYet: string;
    noChatsDescription: string;
    typing: string;
  };

  // Events
  events?: {
    participate: string;
    cancel: string;
    confirm: string;
    buyTicket: string;
    deleteEvent: string;
    deleting: string;
    editCity: string;
    selectNewCity: string;
    cityUpdated: string;
    eventCityChanged: string;
    searchCity: string;
    editDateTime: string;
    selectDateTimeClose: string;
    selectEventDate: string;
    selectStartTime: string;
    notOpenToCategory: string;
    confirmDelete: string;
    confirmDeleteMessage: string;
    cancelButton: string;
    deleteButton: string;
    loading: string;
    loadingOrganizer: string;
    immediately: string;
    additionalInfo: string;
    additionalInfoOptional: string;
    ticketNumber: string;
    participant: string;
    category: string;
    date: string;
    time: string;
    organizedBy: string;
    participants: string;
    openTo: string;
    dressCode: string;
    description: string;
    edit: string;
    save: string;
    close: string;
    title: string;
    location: string;
    price: string;
    free: string;
    spotsLeft: string;
    soldOut: string;
    unlimited: string;
    locationAddress: string;
    addressVisibilityLabel: string;
    hour: string;
    hours: string;
    addressPlaceholder: string;
    additionalInfoPlaceholder: string;
    additionalInfoVisibilityNote: string;
    ticketHoldersOnly: string;
    // Share
    publicShare: string;
    publicShareDescription: string;
    createPublicLinkDescription: string;
    createShareLink: string;
    views: string;
    status: string;
    active: string;
    shareLink: string;
    expiresWhenEventEnds: string;
    share: string;
    preview: string;
    whatVisitorsSee: string;
    allEventDetails: string;
    participantsByCategory: string;
    blurredPhotos: string;
    realtimeSpots: string;
    error: string;
    loadingShareStatus: string;
    linkCreated: string;
    linkCreatedDescription: string;
    sharingDisabled: string;
    sharingDisabledDescription: string;
    linkCopied: string;
    linkCopiedDescription: string;
    cannotCopyLink: string;
    checkOutEvent: string;
    eventDates?: string;
    multiDateInfo?: string;
  };

  // Notifications
  notifications?: {
    noRecentParticipations: string;
    recentParticipations: string;
    willParticipateIn: string;
    showingLatestParticipations: string;
    showingLatestActivities: string;
    feedNotificationsWillAppear: string;
    visitedYou: string;
    mentionedYou: string;
    upvotedYourPost: string;
    commentedOnYourPost: string;
  };

  // Wall
  wall?: {
    willAttendEvent: string;
    andOthers: string;
    andOthersPlural: string;
    noContent: string;
    noContentDescription: string;
    comments: string;
    addComment: string;
    noCommentsYet: string;
    readMore: string;
    deleteConfirm: string;
    delete: string;
    reply?: string;
    loadingComments?: string;
    replyingTo?: string;
    submitComment?: string;
    expired?: string;
    guestLockText?: string;
    anonymousUser?: string;
    unknownCategory?: string;
    firstPostTitle?: string;
    firstPostSubtitle?: string;
    firstPostDescription?: string;
    firstPostButton?: string;
  };

  // BDSM Relationships
  bdsmRelationships?: {
    creatingRelationship: string;
    youAs: string;
    partnerAs: string;
    searchSelectUser: string;
    him?: string;
    her?: string;
    selectPartnerCombination?: string;
    partnerSelected?: string;
    accept: string;
    decline: string;
    pending: string;
    confirm: string;
    sending: string;
    // Contract section
    createContractOptional?: string;
    contractType?: string;
    selectContractType?: string;
    startDate?: string;
    endDate?: string;
    noEndDate?: string;
    makePublic?: string;
    contractText?: string;
    contractTextPlaceholder?: string;
    skipContract?: string;
    saveContinue?: string;
    selectTypeAlert?: string;
    reviewConfirm?: string;
    // Contract viewing
    bdsmContract?: string;
    loadingContract?: string;
    errorLoadingContract?: string;
    public?: string;
    private?: string;
    contractTerms?: string;
    duration?: string;
    indefinite?: string;
    // Contract types
    contractTypes?: {
      '24/7': string;
      'bedroom-only': string;
      'scene-based': string;
      'part-time': string;
      'training': string;
      'master-slave': string;
      'play-partner': string;
    };
    // Contract templates
    templates?: {
      '24/7': (requesterName: string, requesterRole: string, targetName: string, targetRole: string) => string;
      'bedroom-only': (requesterName: string, requesterRole: string, targetName: string, targetRole: string) => string;
      'scene-based': (requesterName: string, requesterRole: string, targetName: string, targetRole: string) => string;
      'part-time': (requesterName: string, requesterRole: string, targetName: string, targetRole: string) => string;
      'training': (requesterName: string, requesterRole: string, targetName: string, targetRole: string) => string;
      'master-slave': (requesterName: string, requesterRole: string, targetName: string, targetRole: string) => string;
      'play-partner': (requesterName: string, requesterRole: string, targetName: string, targetRole: string) => string;
    };
  };
}

export const translations: Record<string, Translations> = {
  en: {
    nickname: {
      title: "Choose your nickname",
      subtitle: "This will be your unique identifier on the platform",
      placeholder: "Enter your nickname",
      checking: "Checking availability...",
      available: "Available",
      notAvailable: "Not available",
      error: "Error checking availability",
      required: "Nickname is required",
      tooShort: "Nickname must be at least 3 characters",
      tooLong: "Nickname must be less than 20 characters",
      infoTitle: "Nickname",
      infoDescription: "Your nickname is unique and identifies you on the platform. We recommend not using your Telegram username as it will be visible to all users."
    },
    category: {
      title: "Select your category",
      subtitle: "Choose the category that best represents you",
      required: "Please select a category",
      categories: {
        COUPLE: "Couple",
        GENTLEMAN: "Gentleman",
        SINGLE_LADY: "Lady",
        DOM: "Dom",
        SUB_M: "Sub (M)",
        SUB_F: "Sub (F)",
        SWITCH_M: "Switch (M)",
        SWITCH_F: "Switch (F)",
        GAY: "Gay",
        LESBIAN: "Lesbian",
        BISEXUAL_M: "Bisexual (M)",
        BISEXUAL_F: "Bisexual (F)",
        TRANSGENDER: "Transgender"
      }
    },
    interests: {
      title: 'What categories are you interested in?',
      subtitle: 'Select the categories you\'re interested in to personalize your experience',
      description: 'Your interests help us show you more relevant content and people. You can always change them later.'
    },
    age: {
      title: "Enter your age",
      subtitle: "You must be at least 18 years old",
      birthDate: "Your birth date",
      partnerBirthDate: "Partner's birth date",
      partnerBirthDateOptional: "Partner's birth date (optional)",
      required: "Birth date is required",
      minimumAge: "You must be at least 18 years old",
      invalidAge: "Please enter a valid age",
      partnerMinimumAge: "Partner must be at least 18 years old",
      birthDateHim: "Birth date (Him)",
      birthDateHer: "Birth date (Her)",
      yourBirthDate: "Your birth date",
      age: "Age",
      years: "years",
      partnerAge: "Your partner's age",
      importantInfo: "Important information",
      ageRequiredInfo: "Age is required to ensure all users on the platform are adults. It's also used in search filters to help users find compatible people."
    },
    location: {
      title: "Where are you located?",
      subtitle: "Select your city to connect with nearby people",
      placeholder: "Search for your city...",
      required: "Please select your city",
      incomplete: "Please select a city from the list",
      invalid: "Please select a valid city",
      yourCity: "Your city",
      searchPlaceholder: "Search for your city...",
      selectedLocation: "Selected location",
      coordinates: "GPS Coordinates (optional)",
      searchDescription: "Search and select your city using autocomplete",
      privacyTitle: "Privacy and location",
      privacyDescription: "Your location is used only to help you find people near you. We never share your exact location, only the city and approximate distance from other users.",
      address: 'Address',
      addressHelp: 'Full location address (visible only to confirmed participants)',
      coordinatesHelp: 'GPS coordinates separated by comma (lat,lng). If not provided, the address will be used for Google Maps.',
      addressVisibility: 'When to show the address',
      addressImmediately: 'Immediately',
      maxHours: 'Max 24h',
      addressVisibilityHelp: 'The address will be visible to confirmed participants this many hours before the event',
      locationAddress: 'Location Address',
      streetAddress: 'Street Address',
      openInGoogleMaps: 'Open in Google Maps',
      addressWillBeRevealed: 'Address will be revealed in:',
      confirmedParticipantsOnly: 'Only confirmed participants can see the address',
      now: 'Now',
    },
    confirm: {
      title: "Confirm your information",
      subtitle: "Please verify all details are correct",
      nickname: "Nickname",
      category: "Category",
      age: "Age",
      location: "Location",
      partner: "Partner",
      years: "years",
      incomplete: "Some information is missing"
    },
    photoOnboarding: {
      welcome: "Welcome to Kinkygram!",
      subtitle: "Upload your first photo to complete your profile",
      uploadSuccess: "✅ Perfect! You've uploaded your first photo.",
      photoManagement: "Profile Photo Management",
      guidelinesTitle: "Photo Guidelines & Rules",
      allowedContent: "Allowed Content",
      allowedFace: "Face photos are not mandatory. Those who choose to show them are aware they will be visible in a Kinky community",
      allowedErotic: "Erotic photos are welcome — no trash, no genitals",
      allowedReal: "Show your best side! Choose photos that represent you",
      prohibitedContent: "Strictly prohibited:",
      prohibitedMinors: "Any content involving minors",
      prohibitedNonConsensual: "Non-consensual content or revenge material",
      prohibitedViolence: "Extreme violence, illegal activities or hate content",
      prohibitedFake: "Fake profiles or stolen photos from other people",
      prohibitedNonPersonal: "Photos that don't represent you (cars, landscapes, memes, cartoons, etc.)",
      warningTitle: "Important:",
      warningText: "Profiles violating these guidelines will be permanently banned. Your Telegram account will not be re-enabled for Kinkygram access.",
      startUsingApp: "Start using the app"
    },

    validations: {
      title: 'Validations',
      metInPerson: 'Met in person',
      playedTogether: 'Played together',
      builtRelationship: 'Built a relationship',
      validation1Title: 'We met in person',
      validation2Title: 'Things got hot',
      validation3Title: 'Friendship relationship',
      validation1Description: 'This validation confirms that you have met in person in real life.',
      validation2Description: 'This validation confirms that the situation between you became intimate and hot.',
      validation3Description: 'This validation confirms that you have built a lasting friendship relationship.',
      exchangeValidation: 'Exchange Validation',
      sendValidation: 'Send Validation',
      pending: 'Pending',
      confirmed: 'Confirmed',
      declined: 'Declined',
      accept: 'Accept',
      decline: 'Decline',
      remove: 'Remove',
      removeConfirm: 'Are you sure you want to remove this validation?',
      confirmSendValidation: 'Are you sure you want to send this validation?',
      confirmDeclineValidation: 'Are you sure you want to decline this validation?',
      validationSentSuccess: 'Validation sent successfully!',
      validationSendError: 'Error sending validation',
      noValidations: 'No validations yet',
      noValidationsDescription: 'Validations will appear here when you receive them',
      validationsConfirmed: 'Confirmed Validations',
      sentByYou: 'sent by you',
      close: 'Close'
    },

    partnerLinking: {
      title: "Linked Partner",
      connected: "Account linked!",
      connectedDescription: "Your partner has access to the shared profile",
      notConnectedDescription: "Enter your partner's Telegram username to manage the couple profile together.",
      inputPlaceholder: "@username or username",
      buttonConnect: "Connect",
      buttonSaving: "Saving...",
      helpText: "The partner with this username will be able to access the shared profile"
    },

    partnerModal: {
      title: "Add Partner",
      titleReadOnly: "Partner Link",
      infoReadOnly: "This couple has linked their partner's Telegram account. Both partners can access and use this shared profile. Their names are used to identify who is chatting.",
      infoReadOnlyNotConnected: "This couple has not yet linked their partner's Telegram account. The partner link feature allows both members of a couple to share access to the same profile.",
      info: "Link your partner's Telegram account to share this profile. Once linked, both of you can use the same account and your names will be used in chats.",
      usernameLabel: "Partner's Telegram Username",
      saving: "(saving...)",
      usernamePlaceholder: "username",
      linkedStatus: "Partner Account Linked",
      linkedDescription: "This couple has successfully linked their partner's Telegram account. Both partners share access to this profile.",
      namesLabel: "Names for Chat Display",
      namesDescription: "These names will be shown when you chat with others",
      firstPartnerPlaceholder: "First partner name",
      secondPartnerPlaceholder: "Second partner name",
      namesReadOnlyTitle: "Chat Display Names",
      namesReadOnlyDescription: "When chatting, the partners use these names to identify who is messaging",
      partnerLinked: "Partner linked",
      addPartner: "Add Partner"
    },

    common: {
      continue: "Continue",
      back: "Back",
      completeRegistration: "Complete Registration",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      spots: "spots",
      day: "day",
      days: "days",
      hours: "hours",
      minutes: "min",
      seconds: "sec",
      participants: "Participants",
      close: "Close",
      confirmed: "Confirmed",
      showTicket: "Show Ticket",
      validations: "Validations"
    },

    banned: {
      title: "Account Banned",
      message: "Your account has been banned",
      reason: "Reason:",
      defaultReason: "Community guidelines violation",
      permanentMessage: "You wasted an opportunity. This account is permanently blocked.",
      supportInfo: "If you believe this is an error, please contact support."
    },

    speedDates: {
      today: "Today",
      tomorrow: "Tomorrow",
      dayAfterTomorrow: "Day after tomorrow",
      openTo: "Open to:"
    },

    chat: {
      requestTitle: "Chat Request",
      continueOnTelegram: "By accepting, the conversation will continue on",
      privacyMessage: "Only your Telegram username will be visible, ensuring your privacy.",
      messageLabel: "Message",
      messagePlaceholder: "Write a message...",
      decline: "Decline",
      accept: "Accept",
      noChatsYet: "No chats yet",
      noChatsDescription: "Your chat requests will appear here",
      typing: "is typing..."
    },

    events: {
      participate: "Participate",
      cancel: "Cancel",
      confirm: "Confirm",
      buyTicket: "Buy Ticket",
      deleteEvent: "Delete Event",
      deleting: "Deleting...",
      editCity: "Edit City",
      selectNewCity: "Select a new city for this event",
      cityUpdated: "City updated",
      eventCityChanged: "Event city changed to",
      searchCity: "Search for a city...",
      editDateTime: "Edit Date and Time",
      selectDateTimeClose: "Select date and time, then close to save",
      selectEventDate: "Select Event Date",
      selectStartTime: "Select Start Time",
      notOpenToCategory: "This event is not open to your category",
      confirmDelete: "Confirm Delete",
      confirmDeleteMessage: "Are you sure you want to delete this event? This action is irreversible and all participants will lose their participation.",
      cancelButton: "Cancel",
      deleteButton: "Delete Event",
      loading: "Loading...",
      loadingOrganizer: "Loading organizer...",
      immediately: "Immediately",
      additionalInfo: "Additional info",
      additionalInfoOptional: "Additional info (optional)",
      ticketNumber: "Ticket number",
      participant: "Participant",
      category: "Category",
      date: "Date",
      time: "Time",
      organizedBy: "Organized by",
      participants: "Participants",
      openTo: "Open to",
      dressCode: "Dress Code",
      description: "Description",
      edit: "Edit",
      save: "Save",
      close: "Close",
      title: "Title",
      location: "Location",
      price: "Price",
      free: "Free",
      spotsLeft: "spots left",
      soldOut: "Sold out",
      unlimited: "Unlimited",
      locationAddress: "Location Address",
      addressVisibilityLabel: "The address will be visible to confirmed participants this many hours before the event",
      hour: "hour",
      hours: "hours",
      addressPlaceholder: "123 Example Street, City",
      additionalInfoPlaceholder: "E.g.: 3rd floor doorbell, intercom SMITH, parking available...",
      additionalInfoVisibilityNote: "This information will only be visible when the address becomes visible",
      ticketHoldersOnly: "Only ticket holders can see the address",
      publicShare: "Public Share",
      publicShareDescription: "Create a link to share outside of Kinkygram",
      createPublicLinkDescription: "Create a public link to share the event on Telegram and other channels. Visitors will see event details and participants with blurred photos.",
      createShareLink: "Create Share Link",
      views: "Views",
      status: "Status",
      active: "Active",
      shareLink: "Share Link",
      expiresWhenEventEnds: "Expires automatically when the event ends",
      share: "Share",
      preview: "Preview",
      whatVisitorsSee: "What visitors see:",
      allEventDetails: "All event details",
      participantsByCategory: "Participants list by category",
      blurredPhotos: "Profile photos blurred for privacy",
      realtimeSpots: "Available spots updated in real time",
      error: "Error",
      loadingShareStatus: "Unable to load share status",
      linkCreated: "Link created!",
      linkCreatedDescription: "The share link has been generated successfully",
      sharingDisabled: "Sharing disabled",
      sharingDisabledDescription: "The public link is no longer accessible",
      linkCopied: "Link copied!",
      linkCopiedDescription: "Paste it wherever you want to share",
      cannotCopyLink: "Unable to copy link",
      checkOutEvent: "Check out this event on Kinkygram!"
    },

    notifications: {
      noRecentParticipations: "No recent participations",
      recentParticipations: "Recent Participations",
      willParticipateIn: "will participate in",
      showingLatestParticipations: "Showing the latest 10 participations",
      showingLatestActivities: "Showing the latest 20 activities",
      feedNotificationsWillAppear: "Your feed notifications will appear here",
      visitedYou: "visited you",
      mentionedYou: "mentioned you",
      upvotedYourPost: "upvoted your post",
      commentedOnYourPost: "commented on your post:"
    },

    wall: {
      willAttendEvent: "will attend the event",
      andOthers: "and",
      andOthersPlural: "and",
      noContent: "No content",
      noContentDescription: "Be the first to share something on the Wall!",
      comments: "Comments",
      addComment: "Add a comment...",
      noCommentsYet: "No comments yet",
      readMore: "Read more →",
      deleteConfirm: "Are you sure you want to delete this post?",
      delete: "Delete",
      reply: "Reply",
      loadingComments: "Loading comments...",
      replyingTo: "Replying to",
      submitComment: "Comment",
      expired: "Expired",
      guestLockText: "🔒 Register to view",
      anonymousUser: "User",
      unknownCategory: "Unknown",
      firstPostTitle: "The Wall awaits you!",
      firstPostSubtitle: "Share your first post to unlock the feed",
      firstPostDescription: "Post a photo or a video to see what the community shares and join future contests with prizes!",
      firstPostButton: "Create your first post"
    },

    bdsmRelationships: {
      creatingRelationship: "Creating BDSM Relationship",
      youAs: "You as",
      partnerAs: "Partner as",
      searchSelectUser: "Search and select the user you want to send a relationship request to",
      him: "Him",
      her: "Her",
      selectPartnerCombination: "Select which partner has which role:",
      accept: "Accept",
      decline: "Decline",
      pending: "Pending",
      confirm: "Confirm",
      sending: "Sending...",
      createContractOptional: "Create a contract for your BDSM relationship (optional)",
      contractType: "Contract Type",
      selectContractType: "Select contract type...",
      startDate: "Start Date",
      endDate: "End Date",
      noEndDate: "No end date (Indefinite)",
      makePublic: "Make contract publicly visible",
      contractText: "Contract Text (You can edit this)",
      contractTextPlaceholder: "Contract text will appear here after selecting a type...",
      skipContract: "Skip Contract",
      saveContinue: "Save & Continue",
      selectTypeAlert: "Please select a contract type and fill in the text",
      reviewConfirm: "Review and confirm your relationship request",
      bdsmContract: "BDSM Contract",
      loadingContract: "Loading contract...",
      errorLoadingContract: "Error loading contract",
      public: "Public",
      private: "Private",
      contractTerms: "Contract Terms",
      duration: "Duration",
      indefinite: "Indefinite",
      contractTypes: {
        '24/7': "24/7 Total Power Exchange",
        'bedroom-only': "Bedroom Only",
        'scene-based': "Scene-Based",
        'part-time': "Part-Time",
        'training': "Training Contract",
        'master-slave': "Master/Slave (M/s)",
        'play-partner': "Play Partner"
      },
      templates: {
        '24/7': (requesterName, requesterRole, targetName, targetRole) => `BDSM 24/7 TOTAL POWER EXCHANGE CONTRACT

Between: ${requesterName} (${requesterRole})
And: ${targetName} (${targetRole})

This contract establishes a 24/7 Total Power Exchange relationship:

1. NATURE OF RELATIONSHIP
   This is a continuous power exchange active 24 hours a day, 7 days a week.

2. ROLES & RESPONSIBILITIES
   - ${requesterRole} agrees to: provide guidance, ensure safety, respect limits, communicate clearly
   - ${targetRole} agrees to: obey within negotiated limits, communicate honestly, use safewords when needed

3. LIMITS
   - Hard Limits (Absolutely Never): [To be discussed and listed]
   - Soft Limits (Requires negotiation): [To be discussed and listed]

4. SAFEWORDS
   - RED: Stop all activity immediately
   - YELLOW: Slow down, need to talk/check-in
   - GREEN: Everything is good, continue

5. PRIVACY & DISCRETION
   Both parties agree to maintain discretion about private aspects of this relationship.

6. TERMINATION
   Either party may terminate this contract with proper communication and respect.`,
        'bedroom-only': (requesterName, requesterRole, targetName, targetRole) => `BDSM BEDROOM-ONLY CONTRACT

Between: ${requesterName} (${requesterRole})
And: ${targetName} (${targetRole})

This contract establishes a BDSM relationship limited to intimate/bedroom activities:

1. SCOPE
   Power exchange is active ONLY during intimate/sexual activities.
   Outside the bedroom, the relationship is equal.

2. ROLES & RESPONSIBILITIES
   - ${requesterRole} agrees to: lead during intimate moments, respect boundaries, ensure safety
   - ${targetRole} agrees to: surrender control during intimate moments, communicate limits, use safewords

3. LIMITS
   - Hard Limits: [To be discussed]
   - Soft Limits: [To be discussed]

4. SAFEWORDS
   - RED: Stop immediately
   - YELLOW: Slow down / check-in
   - GREEN: All good, continue`,
        'scene-based': (requesterName, requesterRole, targetName, targetRole) => `BDSM SCENE-BASED CONTRACT

Between: ${requesterName} (${requesterRole})
And: ${targetName} (${targetRole})

This contract governs pre-negotiated BDSM scenes:

1. SCOPE
   Power exchange occurs ONLY during explicitly negotiated scenes.
   Each scene requires prior discussion and consent.

2. SCENE NEGOTIATION
   Before each scene, both parties will discuss:
   - Activities planned
   - Duration
   - Limits for that specific scene
   - Aftercare needs

3. SAFEWORDS (Always Active During Scenes)
   - RED: Stop immediately
   - YELLOW: Slow down / check-in
   - GREEN: Continue`,
        'part-time': (requesterName, requesterRole, targetName, targetRole) => `BDSM PART-TIME CONTRACT

Between: ${requesterName} (${requesterRole})
And: ${targetName} (${targetRole})

This contract establishes a part-time power exchange relationship:

1. ACTIVE PERIODS
   Power exchange is active during: [Specify: weekends, specific days, etc.]

2. ROLES & RESPONSIBILITIES
   During active periods:
   - ${requesterRole} agrees to: provide guidance, ensure safety, respect limits
   - ${targetRole} agrees to: obey within limits, communicate honestly, use safewords

3. LIMITS
   - Hard Limits: [To be discussed]
   - Soft Limits: [To be discussed]

4. SAFEWORDS
   - RED: Stop immediately
   - YELLOW: Slow down
   - GREEN: Continue`,
        'training': (requesterName, requesterRole, targetName, targetRole) => `BDSM TRAINING CONTRACT

Between: ${requesterName} (${requesterRole})
And: ${targetName} (${targetRole})

This is a TEMPORARY training contract:

1. PURPOSE
   This contract is for training/learning purposes in BDSM practices.

2. TRAINING GOALS
   [To be specified: protocol training, skill development, etc.]

3. DURATION
   This training contract has a specific end date and will be reviewed before renewal.

4. LIMITS & SAFEWORDS
   - Hard Limits: [To be discussed]
   - Soft Limits: [To be discussed]
   - Safewords: RED (stop), YELLOW (slow), GREEN (continue)`,
        'master-slave': (requesterName, requesterRole, targetName, targetRole) => `MASTER/SLAVE CONTRACT

Between: ${requesterName} (${requesterRole})
And: ${targetName} (${targetRole})

This contract establishes a Master/slave (M/s) relationship:

1. NATURE OF RELATIONSHIP
   This is a deep power exchange where the slave consensually surrenders control to the Master.

2. AUTHORITY & CONSENT
   - Master has authority within negotiated boundaries
   - Slave retains the right to safeword and hard limits
   - This is consensual slavery, not real slavery

3. RESPONSIBILITIES
   - Master: provide care, guidance, protection, and training
   - Slave: serve, obey, communicate needs and limits

4. SAFEWORDS & HARD LIMITS
   - RED: Everything stops immediately
   - YELLOW: Slow down, need communication
   - Hard limits must always be respected

5. TERMINATION
   Either party may end this relationship with proper communication.`,
        'play-partner': (requesterName, requesterRole, targetName, targetRole) => `BDSM PLAY PARTNER AGREEMENT

Between: ${requesterName} (${requesterRole})
And: ${targetName} (${targetRole})

This agreement establishes a casual BDSM play partnership:

1. NATURE OF RELATIONSHIP
   This is a non-committed play partnership focused on consensual BDSM activities.

2. BOUNDARIES
   - Activities require prior negotiation and consent
   - Either party can decline any activity at any time
   - Relationship boundaries: [To be discussed]

3. COMMUNICATION
   - Discuss activities, limits, and desires openly before each session
   - Provide feedback after sessions
   - Be honest about availability and expectations

4. SAFEWORDS
   - RED: Stop immediately
   - YELLOW: Slow down / check-in
   - GREEN: Continue

5. RESPECT & DISCRETION
   Both parties agree to respect each other's privacy and maintain discretion.`
      }
    }
  },

  it: {
    nickname: {
      title: "Scegli il tuo nickname",
      subtitle: "Questo sarà il tuo identificativo unico sulla piattaforma",
      placeholder: "Inserisci il tuo nickname",
      checking: "Verifica disponibilità...",
      available: "Disponibile",
      notAvailable: "Non disponibile",
      error: "Errore nella verifica disponibilità",
      required: "Il nickname è obbligatorio",
      tooShort: "Il nickname deve avere almeno 3 caratteri",
      tooLong: "Il nickname deve avere meno di 20 caratteri",
      infoTitle: "Nickname",
      infoDescription: "Il tuo nickname è unico e ti identifica sulla piattaforma. Consigliamo di non usare l'username di Telegram dato che sarà visibile a tutti gli utenti."
    },
    category: {
      title: "Seleziona la tua categoria",
      subtitle: "Scegli la categoria che ti rappresenta meglio",
      required: "Seleziona una categoria",
      categories: {
        COUPLE: "Coppia",
        GENTLEMAN: "Gentleman",
        SINGLE_LADY: "Lady",
        DOM: "Dom",
        SUB_M: "Sub (M)",
        SUB_F: "Sub (F)",
        SWITCH_M: "Switch (M)",
        SWITCH_F: "Switch (F)",
        GAY: "Gay",
        LESBIAN: "Lesbian",
        BISEXUAL_M: "Bisex (M)",
        BISEXUAL_F: "Bisex (F)",
        TRANSGENDER: "Transgender",
        LOVER_M: "Aperto ad avventure extraconiugali",
        LOVER_F: "Aperta ad avventure extraconiugali"
      }
    },
    interests: {
      title: "A quali categorie sei interessato?",
      subtitle: "Seleziona le categorie che ti interessano per personalizzare la tua esperienza",
      required: "Interessi",
      description: "I tuoi interessi ci aiutano a mostrarti contenuti e persone più rilevanti per te. Potrai sempre modificarli in seguito."
    },
    age: {
      title: "Inserisci la tua età",
      subtitle: "Devi avere almeno 18 anni",
      birthDate: "La tua data di nascita",
      partnerBirthDate: "Data di nascita del partner",
      partnerBirthDateOptional: "Data di nascita del partner (opzionale)",
      required: "La data di nascita è obbligatoria",
      minimumAge: "Devi avere almeno 18 anni",
      invalidAge: "Inserisci un'età valida",
      partnerMinimumAge: "Il partner deve avere almeno 18 anni",
      birthDateHim: "Data di nascita (Lui)",
      birthDateHer: "Data di nascita (Lei)",
      yourBirthDate: "La tua data di nascita",
      age: "Età",
      years: "anni",
      partnerAge: "Età del partner",
      importantInfo: "Informazioni importanti",
      ageRequiredInfo: "L'età è richiesta per garantire che tutti gli utenti sulla piattaforma siano maggiorenni. È anche utilizzata nei filtri di ricerca per aiutare gli utenti a trovare persone compatibili."
    },
    location: {
      title: "Dove ti trovi?",
      subtitle: "Seleziona la tua città per connetterti con persone vicine",
      placeholder: "Cerca la tua città...",
      required: "Seleziona la tua città",
      incomplete: "Seleziona una città dalla lista",
      invalid: "Seleziona una città valida",
      yourCity: "La tua città",
      searchPlaceholder: "Cerca la tua città...",
      selectedLocation: "Posizione selezionata",
      coordinates: 'Coordinate GPS (opzionale)',
      searchDescription: "Cerca e seleziona la tua città usando l'autocompletamento",
      privacyTitle: "Privacy e posizione",
      privacyDescription: "La tua posizione viene utilizzata solo per aiutarti a trovare persone vicine a te. Non condividiamo mai la tua posizione esatta, solo la città e la distanza approssimativa da altri utenti.",
      address: 'Indirizzo',
      addressHelp: 'Indirizzo completo della location (visibile solo ai partecipanti confermati)',
      coordinatesHelp: 'Coordinate GPS separate da virgola (lat,lng). Se non inserite, verrà usato l\'indirizzo per Google Maps.',
      addressVisibility: 'Quando mostrare l\'indirizzo',
      addressImmediately: 'Subito',
      maxHours: 'Max 24h',
      addressVisibilityHelp: 'L\'indirizzo sarà visibile ai partecipanti confermati da questo numero di ore prima dell\'evento',
      locationAddress: 'Indirizzo Location',
      streetAddress: 'Indirizzo',
      openInGoogleMaps: 'Apri in Google Maps',
      addressWillBeRevealed: 'L\'indirizzo sarà visibile tra:',
      confirmedParticipantsOnly: 'Solo i partecipanti confermati possono vedere l\'indirizzo',
      now: 'Subito',
    },
    confirm: {
      title: "Conferma le tue informazioni",
      subtitle: "Verifica che tutti i dettagli siano corretti",
      nickname: "Nickname",
      category: "Categoria",
      age: "Età",
      location: "Posizione",
      partner: "Partner",
      years: "anni",
      incomplete: "Alcune informazioni mancano"
    },
    photoOnboarding: {
      welcome: "Benvenuto su Kinkygram!",
      subtitle: "Carica la tua prima foto per completare il profilo",
      uploadSuccess: "✅ Perfetto! Hai caricato la tua prima foto.",
      photoManagement: "Gestione Foto Profilo",
      guidelinesTitle: "Linee Guida e Regole per le Foto",
      allowedContent: "Contenuti Consentiti",
      allowedFace: "Le foto del viso non sono obbligatorie. Chi sceglie di mostrarle è consapevole che sarà visibile in una community Kinky",
      allowedErotic: "Le foto erotiche sono benvenute — no trash, no genitali",
      allowedReal: "Mostra il tuo lato migliore! Scegli foto che ti rappresentano",
      prohibitedContent: "Rigorosamente vietato:",
      prohibitedMinors: "Qualsiasi contenuto che coinvolga minori",
      prohibitedNonConsensual: "Contenuti non consensuali o materiale di vendetta",
      prohibitedViolence: "Violenza estrema, attività illegali o contenuti di odio",
      prohibitedFake: "Profili falsi o foto rubate da altre persone",
      prohibitedNonPersonal: "Foto che non ti rappresentano (auto, paesaggi, meme, vignette, ecc.)",
      warningTitle: "Importante:",
      warningText: "I profili che violano queste linee guida saranno banditi permanentemente. Il tuo account Telegram non verrà riabilitato per l'accesso a Kinkygram.",
      startUsingApp: "Inizia a usare l'app"
    },

    validations: {
      title: 'Validazioni',
      metInPerson: 'ci conosciamo di persona',
      playedTogether: 'la situazione è diventata bollente',
      builtRelationship: 'rapporto di amicizia',
      validation1Title: 'Ci conosciamo di persona',
      validation2Title: 'La situazione è diventata bollente',
      validation3Title: 'Rapporto di amicizia',
      validation1Description: 'Questa validazione conferma che vi siete incontrati di persona nella vita reale.',
      validation2Description: 'Questa validazione conferma che la situazione tra voi è diventata intima e bollente.',
      validation3Description: 'Questa validazione conferma che avete costruito un rapporto di amicizia duraturo.',
      exchangeValidation: 'Scambia Validazione',
      sendValidation: 'Invia Validazione',
      pending: 'In attesa',
      confirmed: 'Confermata',
      declined: 'Rifiutata',
      accept: 'Accetta',
      decline: 'Rifiuta',
      remove: 'Rimuovi',
      removeConfirm: 'Sei sicuro di voler rimuovere questa validazione?',
      confirmSendValidation: 'Sei sicuro di voler inviare questa validazione?',
      confirmDeclineValidation: 'Sei sicuro di voler rifiutare questa validazione?',
      validationSentSuccess: 'Validazione inviata con successo!',
      validationSendError: 'Errore nell\'invio della validazione',
      noValidations: 'Nessuna validazione ancora',
      noValidationsDescription: 'Le validazioni appariranno qui quando le riceverai',
      validationsConfirmed: 'Validazioni Confermate',
      sentByYou: 'inviata da te',
      close: 'Chiudi'
    },

    partnerLinking: {
      title: "Partner Collegato",
      connected: "Account collegato!",
      connectedDescription: "Il tuo partner ha accesso al profilo condiviso",
      notConnectedDescription: "Inserisci l'username Telegram del tuo partner per gestire insieme il profilo di coppia.",
      inputPlaceholder: "@username o username",
      buttonConnect: "Collega",
      buttonSaving: "Salvataggio...",
      helpText: "Il partner con questo username potrà accedere al profilo condiviso"
    },

    partnerModal: {
      title: "Aggiungi Partner",
      titleReadOnly: "Collegamento Partner",
      infoReadOnly: "Questa coppia ha collegato l'account Telegram del partner. Entrambi i partner possono accedere e utilizzare questo profilo condiviso. I loro nomi vengono utilizzati per identificare chi sta chattando.",
      infoReadOnlyNotConnected: "Questa coppia non ha ancora collegato l'account Telegram del partner. La funzione di collegamento partner permette ad entrambi i membri della coppia di condividere l'accesso allo stesso profilo.",
      info: "Collega l'account Telegram del tuo partner per condividere questo profilo. Una volta collegati, entrambi potrete utilizzare lo stesso account e i vostri nomi verranno utilizzati nelle chat.",
      usernameLabel: "Username Telegram del Partner",
      saving: "(salvataggio...)",
      usernamePlaceholder: "username",
      linkedStatus: "Account Partner Collegato",
      linkedDescription: "Questa coppia ha collegato con successo l'account Telegram del partner. Entrambi i partner condividono l'accesso a questo profilo.",
      namesLabel: "Nomi per la Visualizzazione in Chat",
      namesDescription: "Questi nomi verranno mostrati quando chattate con gli altri",
      firstPartnerPlaceholder: "Nome primo partner",
      secondPartnerPlaceholder: "Nome secondo partner",
      namesReadOnlyTitle: "Nomi Visualizzati in Chat",
      namesReadOnlyDescription: "Quando chattano, i partner usano questi nomi per identificare chi sta scrivendo",
      partnerLinked: "Partner collegato",
      addPartner: "Aggiungi Partner"
    },

    common: {
      continue: "Continua",
      back: "Indietro",
      completeRegistration: "Completa Registrazione",
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      spots: "posti",
      day: "giorno",
      days: "giorni",
      hours: "ore",
      minutes: "min",
      seconds: "sec",
      participants: "Partecipanti",
      close: "Chiudi",
      confirmed: "Confermato",
      showTicket: "Mostra Ticket",
      validations: "Validazioni"
    },

    banned: {
      title: "Account Bannato",
      message: "Il tuo account è stato bannato",
      reason: "Motivo:",
      defaultReason: "Violazione delle linee guida della community",
      permanentMessage: "Hai sprecato un'opportunità. Questo account è bloccato per sempre.",
      supportInfo: "Se ritieni che questo sia un errore, contatta il supporto."
    },

    speedDates: {
      today: "Oggi",
      tomorrow: "Domani",
      dayAfterTomorrow: "Dopodomani",
      openTo: "Aperto a:"
    },

    chat: {
      requestTitle: "Richiesta di Chat",
      continueOnTelegram: "Accettando, la conversazione continuerà su",
      privacyMessage: "Sarà visibile solo il tuo username Telegram, garantendo la tua privacy.",
      messageLabel: "Messaggio",
      messagePlaceholder: "Scrivi un messaggio...",
      decline: "Rifiuta",
      accept: "Accetta",
      noChatsYet: "Nessuna chat ancora",
      noChatsDescription: "Le tue richieste di chat appariranno qui",
      typing: "Sta scrivendo..."
    },

    events: {
      participate: "Partecipa",
      cancel: "Annulla",
      confirm: "Conferma",
      buyTicket: "Acquista Ticket",
      deleteEvent: "Elimina Evento",
      deleting: "Eliminazione...",
      editCity: "Modifica Città",
      selectNewCity: "Seleziona una nuova città per questo evento",
      cityUpdated: "Città aggiornata",
      eventCityChanged: "Città dell'evento cambiata in",
      searchCity: "Cerca una città...",
      editDateTime: "Modifica Data e Ora",
      selectDateTimeClose: "Seleziona data e ora, poi chiudi per salvare",
      selectEventDate: "Seleziona Data Evento",
      selectStartTime: "Seleziona Ora Inizio",
      notOpenToCategory: "Questo evento non è aperto alla tua categoria",
      confirmDelete: "Conferma Eliminazione",
      confirmDeleteMessage: "Sei sicuro di voler eliminare questo evento? Questa azione è irreversibile e tutti i partecipanti perderanno la loro partecipazione.",
      cancelButton: "Annulla",
      deleteButton: "Elimina Evento",
      loading: "Caricamento...",
      loadingOrganizer: "Caricamento organizzatore...",
      immediately: "Subito",
      additionalInfo: "Info aggiuntive",
      additionalInfoOptional: "Info aggiuntive (opzionale)",
      ticketNumber: "Numero ticket",
      participant: "Partecipante",
      category: "Categoria",
      date: "Data",
      time: "Ora",
      organizedBy: "Organizzato da",
      participants: "Partecipanti",
      openTo: "Aperto a",
      dressCode: "Dress Code",
      description: "Descrizione",
      edit: "Modifica",
      save: "Salva",
      close: "Chiudi",
      title: "Titolo",
      location: "Luogo",
      price: "Prezzo",
      free: "Gratis",
      spotsLeft: "posti disponibili",
      soldOut: "Esaurito",
      unlimited: "Illimitato",
      locationAddress: "Indirizzo Location",
      addressVisibilityLabel: "L'indirizzo sarà visibile ai partecipanti confermati da questo numero di ore prima dell'evento",
      hour: "ora",
      hours: "ore",
      addressPlaceholder: "Via Example 123, Milano",
      additionalInfoPlaceholder: "Es: Campanello 3° piano, citofono ROSSI, parcheggio disponibile...",
      additionalInfoVisibilityNote: "Queste informazioni saranno visibili solo quando l'indirizzo diventa visibile",
      ticketHoldersOnly: "Solo chi ha acquistato il ticket può vedere l'indirizzo",
      publicShare: "Condivisione Pubblica",
      publicShareDescription: "Crea un link da condividere anche fuori da Kinkygram",
      createPublicLinkDescription: "Crea un link pubblico per condividere l'evento su Telegram e altri canali. Chi accede vedrà i dettagli dell'evento e i partecipanti con foto blurrate.",
      createShareLink: "Crea Link di Condivisione",
      views: "Visualizzazioni",
      status: "Stato",
      active: "Attivo",
      shareLink: "Link di Condivisione",
      expiresWhenEventEnds: "Scade automaticamente quando l'evento finisce",
      share: "Condividi",
      preview: "Anteprima",
      whatVisitorsSee: "Cosa vedono i visitatori:",
      allEventDetails: "Tutti i dettagli dell'evento",
      participantsByCategory: "Lista partecipanti per categoria",
      blurredPhotos: "Foto profilo blurrate per privacy",
      realtimeSpots: "Posti disponibili aggiornati in tempo reale",
      error: "Errore",
      loadingShareStatus: "Impossibile caricare lo stato della condivisione",
      linkCreated: "Link creato!",
      linkCreatedDescription: "Il link di condivisione è stato generato con successo",
      sharingDisabled: "Condivisione disattivata",
      sharingDisabledDescription: "Il link pubblico non è più accessibile",
      linkCopied: "Link copiato!",
      linkCopiedDescription: "Incollalo dove vuoi condividerlo",
      cannotCopyLink: "Impossibile copiare il link",
      checkOutEvent: "Guarda questo evento su Kinkygram!"
    },

    notifications: {
      noRecentParticipations: "Nessuna partecipazione recente",
      recentParticipations: "Partecipazioni Recenti",
      willParticipateIn: "parteciperà a",
      showingLatestParticipations: "Ultime 10 partecipazioni",
      showingLatestActivities: "Ultime 20 attività",
      feedNotificationsWillAppear: "Le notifiche del tuo feed appariranno qui",
      visitedYou: "ti ha visitato",
      mentionedYou: "ti ha menzionato",
      upvotedYourPost: "ha messo Up al tuo post",
      commentedOnYourPost: "ha commentato il tuo post:"
    },

    wall: {
      willAttendEvent: "parteciperanno all'evento",
      andOthers: "ed altri",
      andOthersPlural: "ed altri",
      noContent: "Nessun contenuto",
      noContentDescription: "Sii il primo a condividere qualcosa sul Wall!",
      comments: "Commenti",
      addComment: "Aggiungi un commento...",
      noCommentsYet: "Nessun commento ancora",
      readMore: "Leggi tutto →",
      deleteConfirm: "Sei sicuro di voler eliminare questo post?",
      delete: "Elimina",
      reply: "Rispondi",
      loadingComments: "Caricamento commenti...",
      replyingTo: "Rispondendo a",
      submitComment: "Commenta",
      expired: "Scaduto",
      guestLockText: "🔒 Registrati per vedere",
      anonymousUser: "Utente",
      unknownCategory: "Sconosciuto",
      firstPostTitle: "Il Wall ti aspetta!",
      firstPostSubtitle: "Condividi il tuo primo post per sbloccare il feed",
      firstPostDescription: "Pubblica una foto o un video per vedere cosa condivide la community e partecipare a futuri contest con premi!",
      firstPostButton: "Crea il tuo primo post"
    },

    bdsmRelationships: {
      creatingRelationship: "Creazione Relazione BDSM",
      youAs: "Tu come",
      partnerAs: "Partner come",
      searchSelectUser: "Cerca e seleziona l'utente a cui vuoi inviare una richiesta di relazione",
      him: "Lui",
      her: "Lei",
      selectPartnerCombination: "Seleziona quale partner ha quale ruolo:",
      accept: "Accetta",
      decline: "Rifiuta",
      pending: "In attesa",
      confirm: "Conferma",
      sending: "Invio...",
      createContractOptional: "Crea un contratto per la tua relazione BDSM (opzionale)",
      contractType: "Tipo di Contratto",
      selectContractType: "Seleziona il tipo di contratto...",
      startDate: "Data Inizio",
      endDate: "Data Fine",
      noEndDate: "Senza data di fine (Indefinito)",
      makePublic: "Rendi il contratto pubblicamente visibile",
      contractText: "Testo del Contratto (Puoi modificarlo)",
      contractTextPlaceholder: "Il testo del contratto apparirà qui dopo aver selezionato un tipo...",
      skipContract: "Salta Contratto",
      saveContinue: "Salva e Continua",
      selectTypeAlert: "Seleziona un tipo di contratto e compila il testo",
      reviewConfirm: "Rivedi e conferma la tua richiesta di relazione",
      bdsmContract: "Contratto BDSM",
      loadingContract: "Caricamento contratto...",
      errorLoadingContract: "Errore nel caricamento del contratto",
      public: "Pubblico",
      private: "Privato",
      contractTerms: "Termini del Contratto",
      duration: "Durata",
      indefinite: "Indefinito",
      contractTypes: {
        '24/7': "24/7 Scambio Totale di Potere",
        'bedroom-only': "Solo Camera da Letto",
        'scene-based': "Basato su Scene",
        'part-time': "Part-Time",
        'training': "Contratto di Addestramento",
        'master-slave': "Master/Slave (M/s)",
        'play-partner': "Partner di Gioco"
      },
      templates: {
        '24/7': (requesterName, requesterRole, targetName, targetRole) => `CONTRATTO BDSM 24/7 SCAMBIO TOTALE DI POTERE

Tra: ${requesterName} (${requesterRole})
E: ${targetName} (${targetRole})

Questo contratto stabilisce una relazione di Scambio Totale di Potere 24/7:

1. NATURA DELLA RELAZIONE
   Questo è uno scambio di potere continuo attivo 24 ore al giorno, 7 giorni su 7.

2. RUOLI E RESPONSABILITÀ
   - ${requesterRole} si impegna a: fornire guida, garantire sicurezza, rispettare i limiti, comunicare chiaramente
   - ${targetRole} si impegna a: obbedire entro i limiti negoziati, comunicare onestamente, usare le safeword quando necessario

3. LIMITI
   - Limiti Invalicabili (Assolutamente Mai): [Da discutere ed elencare]
   - Limiti Flessibili (Richiedono negoziazione): [Da discutere ed elencare]

4. SAFEWORDS
   - ROSSO: Ferma immediatamente tutte le attività
   - GIALLO: Rallenta, necessità di parlare/verificare
   - VERDE: Tutto va bene, continua

5. PRIVACY E DISCREZIONE
   Entrambe le parti concordano di mantenere discrezione sugli aspetti privati di questa relazione.

6. TERMINAZIONE
   Ogni parte può terminare questo contratto con comunicazione appropriata e rispetto.`,
        'bedroom-only': (requesterName, requesterRole, targetName, targetRole) => `CONTRATTO BDSM SOLO CAMERA DA LETTO

Tra: ${requesterName} (${requesterRole})
E: ${targetName} (${targetRole})

Questo contratto stabilisce una relazione BDSM limitata alle attività intime/in camera da letto:

1. AMBITO
   Lo scambio di potere è attivo SOLO durante le attività intime/sessuali.
   Fuori dalla camera da letto, la relazione è paritaria.

2. RUOLI E RESPONSABILITÀ
   - ${requesterRole} si impegna a: guidare durante i momenti intimi, rispettare i confini, garantire sicurezza
   - ${targetRole} si impegna a: cedere il controllo durante i momenti intimi, comunicare i limiti, usare le safeword

3. LIMITI
   - Limiti Invalicabili: [Da discutere]
   - Limiti Flessibili: [Da discutere]

4. SAFEWORDS
   - ROSSO: Ferma immediatamente
   - GIALLO: Rallenta / verifica
   - VERDE: Tutto ok, continua`,
        'scene-based': (requesterName, requesterRole, targetName, targetRole) => `CONTRATTO BDSM BASATO SU SCENE

Tra: ${requesterName} (${requesterRole})
E: ${targetName} (${targetRole})

Questo contratto regola scene BDSM pre-negoziate:

1. AMBITO
   Lo scambio di potere avviene SOLO durante scene esplicitamente negoziate.
   Ogni scena richiede discussione e consenso preventivi.

2. NEGOZIAZIONE DELLE SCENE
   Prima di ogni scena, entrambe le parti discuteranno:
   - Attività pianificate
   - Durata
   - Limiti per quella specifica scena
   - Necessità di aftercare

3. SAFEWORDS (Sempre Attive Durante le Scene)
   - ROSSO: Ferma immediatamente
   - GIALLO: Rallenta / verifica
   - VERDE: Continua`,
        'part-time': (requesterName, requesterRole, targetName, targetRole) => `CONTRATTO BDSM PART-TIME

Tra: ${requesterName} (${requesterRole})
E: ${targetName} (${targetRole})

Questo contratto stabilisce una relazione di scambio di potere part-time:

1. PERIODI ATTIVI
   Lo scambio di potere è attivo durante: [Specificare: weekend, giorni specifici, ecc.]

2. RUOLI E RESPONSABILITÀ
   Durante i periodi attivi:
   - ${requesterRole} si impegna a: fornire guida, garantire sicurezza, rispettare i limiti
   - ${targetRole} si impegna a: obbedire entro i limiti, comunicare onestamente, usare le safeword

3. LIMITI
   - Limiti Invalicabili: [Da discutere]
   - Limiti Flessibili: [Da discutere]

4. SAFEWORDS
   - ROSSO: Ferma immediatamente
   - GIALLO: Rallenta
   - VERDE: Continua`,
        'training': (requesterName, requesterRole, targetName, targetRole) => `CONTRATTO BDSM DI ADDESTRAMENTO

Tra: ${requesterName} (${requesterRole})
E: ${targetName} (${targetRole})

Questo è un contratto di addestramento TEMPORANEO:

1. SCOPO
   Questo contratto è per scopi di addestramento/apprendimento nelle pratiche BDSM.

2. OBIETTIVI DI ADDESTRAMENTO
   [Da specificare: addestramento al protocollo, sviluppo di abilità, ecc.]

3. DURATA
   Questo contratto di addestramento ha una data di fine specifica e sarà rivisto prima del rinnovo.

4. LIMITI E SAFEWORDS
   - Limiti Invalicabili: [Da discutere]
   - Limiti Flessibili: [Da discutere]
   - Safewords: ROSSO (ferma), GIALLO (rallenta), VERDE (continua)`,
        'master-slave': (requesterName, requesterRole, targetName, targetRole) => `CONTRATTO MASTER/SLAVE

Tra: ${requesterName} (${requesterRole})
E: ${targetName} (${targetRole})

Questo contratto stabilisce una relazione Master/slave (M/s):

1. NATURA DELLA RELAZIONE
   Questo è un profondo scambio di potere dove lo/la slave cede consensualmente il controllo al/alla Master.

2. AUTORITÀ E CONSENSO
   - Master ha autorità entro confini negoziati
   - Slave mantiene il diritto di usare safeword e limiti invalicabili
   - Questa è schiavitù consensuale, non schiavitù reale

3. RESPONSABILITÀ
   - Master: fornire cura, guida, protezione e addestramento
   - Slave: servire, obbedire, comunicare bisogni e limiti

4. SAFEWORDS E LIMITI INVALICABILI
   - ROSSO: Tutto si ferma immediatamente
   - GIALLO: Rallenta, necessità di comunicare
   - I limiti invalicabili devono sempre essere rispettati

5. TERMINAZIONE
   Ogni parte può terminare questa relazione con comunicazione appropriata.`,
        'play-partner': (requesterName, requesterRole, targetName, targetRole) => `ACCORDO BDSM PARTNER DI GIOCO

Tra: ${requesterName} (${requesterRole})
E: ${targetName} (${targetRole})

Questo accordo stabilisce una partnership BDSM occasionale di gioco:

1. NATURA DELLA RELAZIONE
   Questa è una partnership di gioco non impegnativa focalizzata su attività BDSM consensuali.

2. CONFINI
   - Le attività richiedono negoziazione e consenso preventivi
   - Ogni parte può rifiutare qualsiasi attività in qualsiasi momento
   - Confini della relazione: [Da discutere]

3. COMUNICAZIONE
   - Discutere apertamente attività, limiti e desideri prima di ogni sessione
   - Fornire feedback dopo le sessioni
   - Essere onesti riguardo disponibilità e aspettative

4. SAFEWORDS
   - ROSSO: Ferma immediatamente
   - GIALLO: Rallenta / verifica
   - VERDE: Continua

5. RISPETTO E DISCREZIONE
   Entrambe le parti concordano di rispettare la privacy reciproca e mantenere discrezione.`
      }
    }
  },

  es: {
    nickname: {
      title: "Elige tu nickname",
      subtitle: "Este será tu identificador único en la plataforma",
      placeholder: "Ingresa tu nickname",
      checking: "Verificando disponibilidad...",
      available: "Disponible",
      notAvailable: "No disponible",
      error: "Error al verificar disponibilidad",
      required: "El nickname es obligatorio",
      tooShort: "El nickname debe tener al menos 3 caracteres",
      tooLong: "El nickname debe tener menos de 20 caracteres",
      infoTitle: "Nickname",
      infoDescription: "Tu nickname es único y te identifica en la plataforma. Recomendamos no usar tu nombre de usuario de Telegram ya que será visible para todos los usuarios."
    },
    category: {
      title: "Selecciona tu categoría",
      subtitle: "Elige la categoría que mejor te represente",
      required: "Selecciona una categoría",
      categories: {
        COUPLE: "Pareja",
        GENTLEMAN: "Caballero",
        SINGLE_LADY: "Señorita",
        DOM: "Dom",
        SUB_M: "Sub (H)",
        SUB_F: "Sub (M)",
        SWITCH_M: "Switch (H)",
        SWITCH_F: "Switch (M)",
        GAY: "Gay",
        LESBIAN: "Lesbiana",
        BISEXUAL_M: "Bisexual (H)",
        BISEXUAL_F: "Bisexual (M)",
        TRANSGENDER: "Transgénero",
        LOVER_M: "Abierto a aventuras extramatrimoniales",
        LOVER_F: "Abierta a aventuras extramatrimoniales"
      }
    },
    interests: {
      title: "¿Qué categorías te interesan?",
      subtitle: "Selecciona las categorías de personas que te gustaría conocer",
      description: "Tus intereses nos ayudan a mostrarte perfiles y eventos relevantes. Siempre puedes cambiar estas preferencias más tarde en la configuración de tu perfil."
    },
    age: {
      title: "Ingresa tu edad",
      subtitle: "Debes tener al menos 18 años",
      birthDate: "Tu fecha de nacimiento",
      partnerBirthDate: "Fecha de nacimiento de pareja",
      partnerBirthDateOptional: "Fecha de nacimiento de pareja (opcional)",
      required: "La fecha de nacimiento es obligatoria",
      minimumAge: "Debes tener al menos 18 años",
      invalidAge: "Ingresa una edad válida",
      partnerMinimumAge: "La pareja debe tener al menos 18 años",
      birthDateHim: "Fecha de nacimiento (Él)",
      birthDateHer: "Fecha de nacimiento (Ella)",
      yourBirthDate: "Tu fecha de nacimiento",
      age: "Edad",
      years: "años",
      partnerAge: "Edad de tu pareja",
      importantInfo: "Información importante",
      ageRequiredInfo: "La edad es requerida para asegurar que todos los usuarios en la plataforma sean adultos. También se usa en los filtros de búsqueda para ayudar a los usuarios a encontrar personas compatibles."
    },
    location: {
      title: "¿Dónde te encuentras?",
      subtitle: "Selecciona tu ciudad para conectar con personas cercanas",
      placeholder: "Busca tu ciudad...",
      required: "Selecciona tu ciudad",
      incomplete: "Selecciona una ciudad de la lista",
      invalid: "Selecciona una ciudad válida",
      yourCity: "Tu ciudad",
      searchPlaceholder: "Busca tu ciudad...",
      selectedLocation: "Ubicación seleccionada",
      searchDescription: "Busca y selecciona tu ciudad usando autocompletado",
      privacyTitle: "Privacidad y ubicación",
      privacyDescription: "Tu ubicación se usa solo para ayudarte a encontrar personas cerca de ti. Nunca compartimos tu ubicación exacta, solo la ciudad y la distancia aproximada de otros usuarios.",
      address: 'Dirección',
      addressHelp: 'Dirección completa de la ubicación (visible solo para participantes confirmados)',
      coordinates: 'Coordenadas GPS (opcional)',
      coordinatesHelp: 'Coordenadas GPS separadas por coma (lat,lng). Si no se proporcionan, se utilizará la dirección para Google Maps.',
      addressVisibility: 'Cuándo mostrar la dirección',
      addressImmediately: 'Inmediatamente',
      maxHours: 'Máx 24h',
      addressVisibilityHelp: 'La dirección será visible para los participantes confirmados esta cantidad de horas antes del evento',
      locationAddress: 'Dirección de la Ubicación',
      streetAddress: 'Dirección',
      openInGoogleMaps: 'Abrir en Google Maps',
      addressWillBeRevealed: 'La dirección se revelará en:',
      confirmedParticipantsOnly: 'Solo los participantes confirmados pueden ver la dirección',
      now: 'Ahora',
    },
    confirm: {
      title: "Confirma tu información",
      subtitle: "Verifica que todos los detalles sean correctos",
      nickname: "Nickname",
      category: "Categoría",
      age: "Edad",
      location: "Ubicación",
      partner: "Pareja",
      years: "años",
      incomplete: "Falta información"
    },
    photoOnboarding: {
      welcome: "¡Bienvenido a Kinkygram!",
      subtitle: "Sube tu primera foto para completar tu perfil",
      uploadSuccess: "✅ ¡Perfecto! Has subido tu primera foto.",
      photoManagement: "Gestión de Fotos de Perfil",
      guidelinesTitle: "Pautas y Reglas para Fotos",
      allowedContent: "Contenido Permitido",
      allowedErotic: "Las fotos eróticas son bienvenidas — no trash, no genitales",
      allowedFace: "Las fotos de rostro no son obligatorias. Quien elija mostrarlas es consciente de que serán visibles en una comunidad Kinky",
      allowedReal: "¡Muestra tu mejor lado! Elige fotos que te representen",
      prohibitedContent: "Estrictamente prohibido:",
      prohibitedMinors: "Cualquier contenido que involucre menores",
      prohibitedNonConsensual: "Contenido no consensual o material de venganza",
      prohibitedViolence: "Violencia extrema, actividades ilegales o contenido de odio",
      prohibitedFake: "Perfiles falsos o fotos robadas de otras personas",
      prohibitedNonPersonal: "Fotos que no te representan (coches, paisajes, memes, etc.)",
      warningTitle: "Importante:",
      warningText: "Los perfiles que violen estas pautas serán prohibidos permanentemente. Tu cuenta de Telegram no será rehabilitada para el acceso a Kinkygram.",
      startUsingApp: "Comenzar a usar la app"
    },

    validations: {
      title: 'Validaciones',
      metInPerson: 'Met in person',
      playedTogether: 'Played together',
      builtRelationship: 'Built a relationship',
      validation1Title: 'We met in person',
      validation2Title: 'Things got hot',
      validation3Title: 'Friendship relationship',
      validation1Description: 'Esta validación confirma que te has conocido en persona en la vida real.',
      validation2Description: 'Esta validación confirma que la situación entre vosotros se volvió íntima y apasionada.',
      validation3Description: 'Esta validación confirma que has construido una relación de amistad duradera.',
      exchangeValidation: 'Intercambiar una validación',
      sendValidation: 'Enviar Validación',
      pending: 'Pendiente',
      confirmed: 'Confirmada',
      declined: 'Rechazada',
      accept: 'Aceptar',
      decline: 'Rechazar',
      remove: 'Remove',
      removeConfirm: '¿Estás seguro de que quieres eliminar esta validación?',
      confirmSendValidation: '¿Estás seguro de que quieres enviar esta validación?',
      confirmDeclineValidation: '¿Estás seguro de que quieres rechazar esta validación?',
      validationSentSuccess: '¡Validación enviada con éxito!',
      validationSendError: 'Error al enviar la validación',
      noValidations: 'Sin validaciones',
      noValidationsDescription: 'Las validaciones recibidas aparecerán aquí',
      validationsConfirmed: 'Validaciones confirmadas',
      sentByYou: 'Enviada por ti',
      close: 'Close'
    },

    partnerLinking: {
      title: "Pareja Vinculada",
      connected: "¡Cuenta vinculada!",
      connectedDescription: "Tu pareja tiene acceso al perfil compartido",
      notConnectedDescription: "Ingresa el nombre de usuario de Telegram de tu pareja para gestionar juntos el perfil de pareja.",
      inputPlaceholder: "@usuario o usuario",
      buttonConnect: "Vincular",
      buttonSaving: "Guardando...",
      helpText: "La pareja con este nombre de usuario podrá acceder al perfil compartido"
    },

    partnerModal: {
      title: "Agregar Pareja",
      titleReadOnly: "Vinculación de Pareja",
      infoReadOnly: "Esta pareja ha vinculado la cuenta de Telegram de su pareja. Ambas partes pueden acceder y usar este perfil compartido. Sus nombres se usan para identificar quién está chateando.",
      infoReadOnlyNotConnected: "Esta pareja aún no ha vinculado la cuenta de Telegram de su pareja. La función de vinculación de pareja permite a ambos miembros compartir el acceso al mismo perfil.",
      info: "Vincula la cuenta de Telegram de tu pareja para compartir este perfil. Una vez vinculados, ambos podrán usar la misma cuenta y sus nombres se usarán en los chats.",
      usernameLabel: "Nombre de Usuario de Telegram de la Pareja",
      saving: "(guardando...)",
      usernamePlaceholder: "usuario",
      linkedStatus: "Cuenta de Pareja Vinculada",
      linkedDescription: "Esta pareja ha vinculado exitosamente la cuenta de Telegram de su pareja. Ambas partes comparten acceso a este perfil.",
      namesLabel: "Nombres para Mostrar en el Chat",
      namesDescription: "Estos nombres se mostrarán cuando chatees con otros",
      firstPartnerPlaceholder: "Nombre del primer miembro",
      secondPartnerPlaceholder: "Nombre del segundo miembro",
      namesReadOnlyTitle: "Nombres Mostrados en el Chat",
      namesReadOnlyDescription: "Al chatear, los miembros de la pareja usan estos nombres para identificar quién está escribiendo",
      partnerLinked: "Pareja vinculada",
      addPartner: "Agregar Pareja"
    },

    common: {
      continue: "Continuar",
      back: "Atrás",
      completeRegistration: "Completar Registro",
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      spots: "plazas",
      day: "día",
      days: "días",
      hours: "horas",
      minutes: "min",
      seconds: "seg",
      participants: "Participantes",
      close: "Cerrar",
      confirmed: "Confirmado",
      showTicket: "Mostrar Ticket",
      validations: "Validaciones"
    },

    banned: {
      title: "Cuenta Baneada",
      message: "Tu cuenta ha sido baneada",
      reason: "Motivo:",
      defaultReason: "Violación de las directrices de la comunidad",
      permanentMessage: "Desperdiciaste una oportunidad. Esta cuenta está bloqueada permanentemente.",
      supportInfo: "Si crees que esto es un error, contacta con soporte."
    },

    speedDates: {
      today: "Hoy",
      tomorrow: "Mañana",
      dayAfterTomorrow: "Pasado mañana",
      openTo: "Abierto a:"
    },

    chat: {
      requestTitle: "Solicitud de Chat",
      continueOnTelegram: "Al aceptar, la conversación continuará en",
      privacyMessage: "Solo será visible tu nombre de usuario de Telegram, garantizando tu privacidad.",
      messageLabel: "Mensaje",
      messagePlaceholder: "Escribe un mensaje...",
      decline: "Rechazar",
      accept: "Aceptar",
      noChatsYet: "Sin chats aún",
      noChatsDescription: "Tus solicitudes de chat aparecerán aquí",
      typing: "Está escribiendo..."
    },
    events: {
      participate: "Participar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      buyTicket: "Comprar Ticket",
      deleteEvent: "Eliminar Evento",
      deleting: "Eliminando...",
      editCity: "Editar Ciudad",
      selectNewCity: "Selecciona una nueva ciudad para este evento",
      cityUpdated: "Ciudad actualizada",
      eventCityChanged: "Ciudad del evento cambiada a",
      searchCity: "Buscar una ciudad...",
      editDateTime: "Editar Fecha y Hora",
      selectDateTimeClose: "Selecciona fecha y hora, luego cierra para guardar",
      selectEventDate: "Seleccionar Fecha del Evento",
      selectStartTime: "Seleccionar Hora de Inicio",
      notOpenToCategory: "Este evento no está abierto a tu categoría",
      confirmDelete: "Confirmar Eliminación",
      confirmDeleteMessage: "¿Estás seguro de que quieres eliminar este evento? Esta acción es irreversible y todos los participantes perderán su participación.",
      cancelButton: "Cancelar",
      deleteButton: "Eliminar Evento",
      loading: "Cargando...",
      loadingOrganizer: "Cargando organizador...",
      immediately: "Inmediatamente",
      additionalInfo: "Info adicional",
      additionalInfoOptional: "Info adicional (opcional)",
      ticketNumber: "Número de ticket",
      participant: "Participante",
      category: "Categoría",
      date: "Fecha",
      time: "Hora",
      organizedBy: "Organizado por",
      participants: "Participantes",
      openTo: "Abierto a",
      dressCode: "Código de Vestimenta",
      description: "Descripción",
      edit: "Editar",
      save: "Guardar",
      close: "Cerrar",
      title: "Título",
      location: "Ubicación",
      price: "Precio",
      free: "Gratis",
      spotsLeft: "plazas disponibles",
      soldOut: "Agotado",
      unlimited: "Ilimitado",
      locationAddress: "Dirección del Lugar",
      addressVisibilityLabel: "La dirección será visible para los participantes confirmados este número de horas antes del evento",
      hour: "hora",
      hours: "horas",
      addressPlaceholder: "Calle Ejemplo 123, Ciudad",
      additionalInfoPlaceholder: "Ej: Timbre 3er piso, interfono GARCÍA, estacionamiento disponible...",
      additionalInfoVisibilityNote: "Esta información solo será visible cuando la dirección se haga visible",
      ticketHoldersOnly: "Solo los titulares de entradas pueden ver la dirección",
      publicShare: "Compartir Público",
      publicShareDescription: "Crea un enlace para compartir fuera de Kinkygram",
      createPublicLinkDescription: "Crea un enlace público para compartir el evento en Telegram y otros canales. Los visitantes verán los detalles del evento y los participantes con fotos borrosas.",
      createShareLink: "Crear Enlace para Compartir",
      views: "Visualizaciones",
      status: "Estado",
      active: "Activo",
      shareLink: "Enlace para Compartir",
      expiresWhenEventEnds: "Expira automáticamente cuando termina el evento",
      share: "Compartir",
      preview: "Vista Previa",
      whatVisitorsSee: "Qué ven los visitantes:",
      allEventDetails: "Todos los detalles del evento",
      participantsByCategory: "Lista de participantes por categoría",
      blurredPhotos: "Fotos de perfil borrosas por privacidad",
      realtimeSpots: "Plazas disponibles actualizadas en tiempo real",
      error: "Error",
      loadingShareStatus: "No se puede cargar el estado de compartir",
      linkCreated: "¡Enlace creado!",
      linkCreatedDescription: "El enlace para compartir se ha generado con éxito",
      sharingDisabled: "Compartir desactivado",
      sharingDisabledDescription: "El enlace público ya no es accesible",
      linkCopied: "¡Enlace copiado!",
      linkCopiedDescription: "Pégalo donde quieras compartirlo",
      cannotCopyLink: "No se puede copiar el enlace",
      checkOutEvent: "¡Mira este evento en Kinkygram!"
    },

    notifications: {
      noRecentParticipations: "Sin participaciones recientes",
      recentParticipations: "Participaciones Recientes",
      willParticipateIn: "participará en",
      showingLatestParticipations: "Mostrando las últimas 10 participaciones",
      showingLatestActivities: "Mostrando las últimas 20 actividades",
      feedNotificationsWillAppear: "Las notificaciones de tu feed aparecerán aquí",
      visitedYou: "te ha visitado",
      mentionedYou: "te ha mencionado",
      upvotedYourPost: "dio Up a tu publicación",
      commentedOnYourPost: "comentó tu publicación:"
    },

    wall: {
      willAttendEvent: "asistirán al evento",
      andOthers: "y",
      andOthersPlural: "y",
      noContent: "Sin contenido",
      noContentDescription: "¡Sé el primero en compartir algo en el Muro!",
      comments: "Comentarios",
      addComment: "Añadir un comentario...",
      noCommentsYet: "Sin comentarios aún",
      readMore: "Leer más →",
      deleteConfirm: "¿Estás seguro de que quieres eliminar esta publicación?",
      delete: "Eliminar",
      reply: "Responder",
      loadingComments: "Cargando comentarios...",
      replyingTo: "Respondiendo a",
      submitComment: "Comentar",
      expired: "Expirado",
      guestLockText: "🔒 Regístrate para ver",
      anonymousUser: "Usuario",
      unknownCategory: "Desconocido",
      firstPostTitle: "\u00a1El Muro te espera!",
      firstPostSubtitle: "Comparte tu primer post para desbloquear el feed",
      firstPostDescription: "\u00a1Publica una foto o un video para ver lo que comparte la comunidad y participar en futuros concursos con premios!",
      firstPostButton: "Crea tu primer post"
    },

    bdsmRelationships: {
      creatingRelationship: "Creando Relación BDSM",
      youAs: "Tú como",
      partnerAs: "Pareja como",
      searchSelectUser: "Busca y selecciona el usuario al que quieres enviar una solicitud de relación",
      him: "Él",
      her: "Ella",
      selectPartnerCombination: "Selecciona qué pareja tiene qué rol:",
      accept: "Aceptar",
      decline: "Rechazar",
      pending: "Pendiente",
      confirm: "Confirmar",
      sending: "Enviando..."
    }
  },

  de: {
    nickname: {
      title: "Wähle deinen Nickname",
      subtitle: "Dies wird dein Anzeigename auf Kinkygram sein",
      placeholder: "Gib deinen Nickname ein",
      checking: "Verfügbarkeit prüfen...",
      available: "Verfügbar",
      notAvailable: "Nicht verfügbar",
      error: "Fehler bei der Überprüfung",
      required: "Nickname ist erforderlich",
      tooShort: "Nickname muss mindestens 3 Zeichen haben",
      tooLong: "Nickname darf 30 Zeichen nicht überschreiten",
      infoTitle: "Nickname",
      infoDescription: "Dein Nickname ist einzigartig und identifiziert dich auf der Plattform. Wir empfehlen, deinen Telegram-Benutzernamen nicht zu verwenden, da er für alle Benutzer sichtbar sein wird."
    },
    category: {
      title: "Wähle deine Kategorie",
      subtitle: "Wähle die Kategorie, die dich am besten repräsentiert",
      required: "Bitte wähle eine Kategorie",
      categories: {
        COUPLE: "Paar",
        GENTLEMAN: "Gentleman",
        SINGLE_LADY: "Lady",
        DOM: "Dom",
        SUB_M: "Sub (M)",
        SUB_F: "Sub (W)",
        SWITCH_M: "Switch (M)",
        SWITCH_F: "Switch (W)",
        GAY: "Schwul",
        LESBIAN: "Lesbisch",
        BISEXUAL_M: "Bisexuell (M)",
        BISEXUAL_F: "Bisexuell (W)",
        TRANSGENDER: "Transgender",
        LOVER_M: "Offen für außereheliche Abenteuer",
        LOVER_F: "Offen für außereheliche Abenteuer"
      }
    },
    interests: {
      title: 'Welche Kategorien interessieren dich?',
      subtitle: 'Wähle die Kategorien von Personen aus, die du treffen möchtest',
      description: 'Deine Interessen helfen uns, dir relevante Profile und Veranstaltungen zu zeigen. Du kannst diese Einstellungen jederzeit später in deinen Profileinstellungen ändern.'
    },
    age: {
      title: "Gib dein Alter ein",
      subtitle: "Du musst mindestens 18 Jahre alt sein",
      birthDate: "Dein Geburtsdatum",
      partnerBirthDate: "Geburtsdatum des Partners",
      partnerBirthDateOptional: "Geburtsdatum des Partners (optional)",
      required: "Geburtsdatum ist erforderlich",
      minimumAge: "Du musst mindestens 18 Jahre alt sein",
      invalidAge: "Bitte gib ein gültiges Alter ein",
      partnerMinimumAge: "Partner muss mindestens 18 Jahre alt sein",
      birthDateHim: "Geburtsdatum (Er)",
      birthDateHer: "Geburtsdatum (Sie)",
      yourBirthDate: "Dein Geburtsdatum",
      age: "Alter",
      years: "Jahre",
      partnerAge: "Alter deines Partners",
      importantInfo: "Wichtige Informationen",
      ageRequiredInfo: "Das Alter ist erforderlich, um sicherzustellen, dass alle Benutzer auf der Plattform erwachsen sind. Es wird auch in Suchfiltern verwendet, um Benutzern zu helfen, kompatible Personen zu finden."
    },
    location: {
      title: "Wo befindest du dich?",
      subtitle: "Wähle deine Stadt, um dich mit Menschen in der Nähe zu verbinden",
      placeholder: "Suche deine Stadt...",
      required: "Bitte wähle deine Stadt",
      incomplete: "Bitte wähle eine Stadt aus der Liste",
      invalid: "Bitte wähle eine gültige Stadt",
      yourCity: "Deine Stadt",
      searchPlaceholder: "Suche deine Stadt...",
      selectedLocation: "Ausgewählter Standort",
      searchDescription: "Suche und wähle deine Stadt mit Autovervollständigung",
      privacyTitle: "Datenschutz und Standort",
      privacyDescription: "Dein Standort wird nur verwendet, um dir zu helfen, Menschen in deiner Nähe zu finden. Wir teilen niemals deinen genauen Standort, nur die Stadt und ungefähre Entfernung zu anderen Benutzern.",
      address: 'Adresse',
      addressHelp: 'Vollständige Adresse des Ortes (nur für bestätigte Teilnehmer sichtbar)',
      coordinates: 'GPS-Koordinaten (optional)',
      coordinatesHelp: 'GPS-Koordinaten durch Komma getrennt (Breitengrad,Längengrad). Wenn nicht angegeben, wird die Adresse für Google Maps verwendet.',
      addressVisibility: 'Wann die Adresse angezeigt werden soll',
      addressImmediately: 'Sofort',
      maxHours: 'Max. 24 Std.',
      addressVisibilityHelp: 'Die Adresse wird den bestätigten Teilnehmern so viele Stunden vor dem Ereignis angezeigt',
      locationAddress: 'Standort-Adresse',
      streetAddress: 'Straßenadresse',
      openInGoogleMaps: 'In Google Maps öffnen',
      addressWillBeRevealed: 'Die Adresse wird enthüllt in:',
      confirmedParticipantsOnly: 'Nur bestätigte Teilnehmer können die Adresse sehen',
      now: 'Jetzt',
    },
    confirm: {
      title: "Bestätige deine Informationen",
      subtitle: "Bitte überprüfe, ob alle Details korrekt sind",
      nickname: "Nickname",
      category: "Kategorie",
      age: "Alter",
      location: "Standort",
      partner: "Partner",
      years: "Jahre",
      incomplete: "Einige Informationen fehlen"
    },
    photoOnboarding: {
      welcome: "Willkommen bei Kinkygram!",
      subtitle: "Lade dein erstes Foto hoch, um dein Profil zu vervollständigen",
      uploadSuccess: "✅ Perfekt! Du hast dein erstes Foto hochgeladen.",
      photoManagement: "Profil-Foto-Verwaltung",
      guidelinesTitle: "Foto-Richtlinien & Regeln",
      allowedContent: "Erlaubter Inhalt",
      allowedErotic: "Erotische Fotos sind willkommen — kein Trash, keine Genitalien",
      allowedFace: "Gesichtsfotos sind nicht verpflichtend. Wer sich entscheidet, sie zu zeigen, ist sich bewusst, dass sie in einer Kinky-Community sichtbar sein werden",
      allowedReal: "Zeig deine beste Seite! Wähle Fotos, die dich repräsentieren",
      prohibitedContent: "Streng verboten:",
      prohibitedMinors: "Jeglicher Inhalt mit Minderjährigen",
      prohibitedNonConsensual: "Nicht-einvernehmlicher Inhalt oder Rachepornographie",
      prohibitedViolence: "Extreme Gewalt, illegale Aktivitäten oder Hassinhalt",
      prohibitedFake: "Gefälschte Profile oder gestohlene Fotos von anderen Personen",
      prohibitedNonPersonal: "Fotos, die dich nicht repräsentieren (Autos, Landschaften, Memes, Cartoons usw.)",
      warningTitle: "Wichtig:",
      warningText: "Profile, die gegen diese Richtlinien verstoßen, werden permanent gesperrt. Dein Telegram-Account wird nicht für den Kinkygram-Zugang wieder aktiviert.",
      startUsingApp: "App verwenden"
    },

    validations: {
      title: 'Validierungen',
      metInPerson: 'Met in person',
      playedTogether: 'Played together',
      builtRelationship: 'Built a relationship',
      validation1Title: 'Wir kennen uns!',
      validation2Title: 'Die Situation wurde heiß',
      validation3Title: 'Freundschaftsbeziehung',
      validation1Description: 'Diese Validierung bestätigt, dass Sie sich im wirklichen Leben persönlich getroffen haben.',
      validation2Description: 'Diese Validierung bestätigt, dass die Situation zwischen Ihnen intim und heiß wurde.',
      validation3Description: 'Diese Validierung bestätigt, dass Sie eine dauerhafte Freundschaftsbeziehung aufgebaut haben.',
      exchangeValidation: 'Eine Validierung austauschen',
      sendValidation: 'Validierung senden',
      pending: 'Ausstehend',
      confirmed: 'Bestätigt',
      declined: 'Abgelehnt',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
      remove: 'Remove',
      removeConfirm: 'Bist du sicher, dass du diese Validierung entfernen möchtest?',
      confirmSendValidation: "Sind Sie sicher, dass Sie diese Validierung senden möchten?",
      confirmDeclineValidation: 'Sind Sie sicher, dass Sie diese Validierung ablehnen möchten?',
      validationSentSuccess: 'Validierung erfolgreich gesendet!',
      validationSendError: 'Fehler beim Senden der Validierung',
      noValidations: 'Keine Validierungen',
      noValidationsDescription: 'Erhaltene Validierungen werden hier angezeigt',
      validationsConfirmed: 'Bestätigte Validierungen',
      sentByYou: 'Von dir gesendet',
      close: 'Close'
    },

    partnerLinking: {
      title: "Verknüpfter Partner",
      connected: "Konto verknüpft!",
      connectedDescription: "Dein Partner hat Zugriff auf das gemeinsame Profil",
      notConnectedDescription: "Gib den Telegram-Benutzernamen deines Partners ein, um das Paarprofil gemeinsam zu verwalten.",
      inputPlaceholder: "@Benutzername oder Benutzername",
      buttonConnect: "Verknüpfen",
      buttonSaving: "Wird gespeichert...",
      helpText: "Der Partner mit diesem Benutzernamen kann auf das gemeinsame Profil zugreifen"
    },

    partnerModal: {
      title: "Partner Hinzufügen",
      titleReadOnly: "Partner-Verknüpfung",
      infoReadOnly: "Dieses Paar hat das Telegram-Konto des Partners verknüpft. Beide Partner können auf dieses gemeinsame Profil zugreifen und es verwenden. Ihre Namen werden verwendet, um zu identifizieren, wer chattet.",
      infoReadOnlyNotConnected: "Dieses Paar hat das Telegram-Konto des Partners noch nicht verknüpft. Die Partner-Verknüpfungsfunktion ermöglicht es beiden Mitgliedern, den Zugriff auf dasselbe Profil zu teilen.",
      info: "Verknüpfe das Telegram-Konto deines Partners, um dieses Profil zu teilen. Sobald verknüpft, können beide dasselbe Konto verwenden und eure Namen werden in Chats verwendet.",
      usernameLabel: "Telegram-Benutzername des Partners",
      saving: "(wird gespeichert...)",
      usernamePlaceholder: "Benutzername",
      linkedStatus: "Partner-Konto Verknüpft",
      linkedDescription: "Dieses Paar hat das Telegram-Konto des Partners erfolgreich verknüpft. Beide Partner teilen den Zugriff auf dieses Profil.",
      namesLabel: "Namen für Chat-Anzeige",
      namesDescription: "Diese Namen werden angezeigt, wenn du mit anderen chattest",
      firstPartnerPlaceholder: "Name des ersten Partners",
      secondPartnerPlaceholder: "Name des zweiten Partners",
      namesReadOnlyTitle: "Angezeigte Chat-Namen",
      namesReadOnlyDescription: "Beim Chatten verwenden die Partner diese Namen, um zu identifizieren, wer schreibt",
      partnerLinked: "Partner verknüpft",
      addPartner: "Partner Hinzufügen"
    },

    common: {
      continue: "Weiter",
      back: "Zurück",
      completeRegistration: "Registrierung abschließen",
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      spots: "Plätze",
      day: "Tag",
      days: "Tage",
      hours: "Std",
      minutes: "Min",
      seconds: "Sek",
      participants: "Teilnehmer",
      close: "Schließen",
      confirmed: "Bestätigt",
      showTicket: "Ticket anzeigen",
      validations: "Validierungen"
    },

    banned: {
      title: "Konto Gesperrt",
      message: "Dein Konto wurde gesperrt",
      reason: "Grund:",
      defaultReason: "Verstoß gegen Community-Richtlinien",
      permanentMessage: "Sie haben eine Chance verpasst. Dieses Konto ist dauerhaft gesperrt.",
      supportInfo: "Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich an den Support."
    },

    speedDates: {
      today: "Heute",
      tomorrow: "Morgen",
      dayAfterTomorrow: "Übermorgen",
      openTo: "Offen für:"
    },

    chat: {
      requestTitle: "Chat-Anfrage",
      continueOnTelegram: "Durch Akzeptieren wird die Konversation fortgesetzt auf",
      privacyMessage: "Nur dein Telegram-Benutzername wird sichtbar sein und deine Privatsphäre gewährleisten.",
      messageLabel: "Nachricht",
      messagePlaceholder: "Schreibe eine Nachricht...",
      decline: "Ablehnen",
      accept: "Akzeptieren",
      noChatsYet: "Noch keine Chats",
      noChatsDescription: "Deine Chat-Anfragen werden hier erscheinen",
      typing: "schreibt..."
    },
    events: {
      participate: "Teilnehmen",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      buyTicket: "Ticket kaufen",
      deleteEvent: "Event löschen",
      deleting: "Löschen...",
      editCity: "Stadt bearbeiten",
      selectNewCity: "Wähle eine neue Stadt für dieses Event",
      cityUpdated: "Stadt aktualisiert",
      eventCityChanged: "Event-Stadt geändert zu",
      searchCity: "Stadt suchen...",
      editDateTime: "Datum und Uhrzeit bearbeiten",
      selectDateTimeClose: "Datum und Uhrzeit auswählen, dann schließen zum Speichern",
      selectEventDate: "Event-Datum auswählen",
      selectStartTime: "Startzeit auswählen",
      notOpenToCategory: "Dieses Event ist für deine Kategorie nicht zugänglich",
      confirmDelete: "Löschen bestätigen",
      confirmDeleteMessage: "Bist du sicher, dass du dieses Event löschen möchtest? Diese Aktion ist unwiderruflich und alle Teilnehmer verlieren ihre Teilnahme.",
      cancelButton: "Abbrechen",
      deleteButton: "Event löschen",
      loading: "Laden...",
      loadingOrganizer: "Organisator laden...",
      immediately: "Sofort",
      additionalInfo: "Zusätzliche Info",
      additionalInfoOptional: "Zusätzliche Info (optional)",
      ticketNumber: "Ticket-Nummer",
      participant: "Teilnehmer",
      category: "Kategorie",
      date: "Datum",
      time: "Uhrzeit",
      organizedBy: "Organisiert von",
      participants: "Teilnehmer",
      openTo: "Offen für",
      dressCode: "Dresscode",
      description: "Beschreibung",
      edit: "Bearbeiten",
      save: "Speichern",
      close: "Schließen",
      title: "Titel",
      location: "Ort",
      price: "Preis",
      free: "Kostenlos",
      spotsLeft: "Plätze verfügbar",
      soldOut: "Ausverkauft",
      unlimited: "Unbegrenzt",
      locationAddress: "Veranstaltungsort-Adresse",
      addressVisibilityLabel: "Die Adresse wird für bestätigte Teilnehmer diese Anzahl von Stunden vor dem Event sichtbar",
      hour: "Stunde",
      hours: "Stunden",
      addressPlaceholder: "Beispielstraße 123, Stadt",
      additionalInfoPlaceholder: "Z.B.: Klingel 3. Stock, Gegensprechanlage MÜLLER, Parkplatz vorhanden...",
      additionalInfoVisibilityNote: "Diese Informationen werden erst sichtbar, wenn die Adresse sichtbar wird",
      ticketHoldersOnly: "Nur Ticketinhaber können die Adresse sehen",
      publicShare: "Öffentliches Teilen",
      publicShareDescription: "Erstelle einen Link zum Teilen außerhalb von Kinkygram",
      createPublicLinkDescription: "Erstelle einen öffentlichen Link, um das Event auf Telegram und anderen Kanälen zu teilen. Besucher sehen Event-Details und Teilnehmer mit verschwommenen Fotos.",
      createShareLink: "Teilen-Link erstellen",
      views: "Aufrufe",
      status: "Status",
      active: "Aktiv",
      shareLink: "Teilen-Link",
      expiresWhenEventEnds: "Läuft automatisch ab, wenn das Event endet",
      share: "Teilen",
      preview: "Vorschau",
      whatVisitorsSee: "Was Besucher sehen:",
      allEventDetails: "Alle Event-Details",
      participantsByCategory: "Teilnehmerliste nach Kategorie",
      blurredPhotos: "Profilfotos verschwommen für Privatsphäre",
      realtimeSpots: "Verfügbare Plätze in Echtzeit aktualisiert",
      error: "Fehler",
      loadingShareStatus: "Teilen-Status kann nicht geladen werden",
      linkCreated: "Link erstellt!",
      linkCreatedDescription: "Der Teilen-Link wurde erfolgreich generiert",
      sharingDisabled: "Teilen deaktiviert",
      sharingDisabledDescription: "Der öffentliche Link ist nicht mehr zugänglich",
      linkCopied: "Link kopiert!",
      linkCopiedDescription: "Füge ihn ein, wo du ihn teilen möchtest",
      cannotCopyLink: "Link kann nicht kopiert werden",
      checkOutEvent: "Schau dir dieses Event auf Kinkygram an!"
    },

    notifications: {
      noRecentParticipations: "Keine aktuellen Teilnahmen",
      recentParticipations: "Aktuelle Teilnahmen",
      willParticipateIn: "wird teilnehmen an",
      showingLatestParticipations: "Die letzten 10 Teilnahmen werden angezeigt",
      showingLatestActivities: "Die letzten 20 Aktivitäten werden angezeigt",
      feedNotificationsWillAppear: "Deine Feed-Benachrichtigungen erscheinen hier",
      visitedYou: "hat dich besucht",
      mentionedYou: "hat dich erwähnt",
      upvotedYourPost: "hat deinen Beitrag geliked",
      commentedOnYourPost: "hat deinen Beitrag kommentiert:"
    },

    wall: {
      willAttendEvent: "werden an der Veranstaltung teilnehmen",
      andOthers: "und",
      andOthersPlural: "und",
      noContent: "Kein Inhalt",
      noContentDescription: "Sei der Erste, der etwas auf der Pinnwand teilt!",
      comments: "Kommentare",
      addComment: "Kommentar hinzufügen...",
      noCommentsYet: "Noch keine Kommentare",
      readMore: "Mehr lesen →",
      deleteConfirm: "Bist du sicher, dass du diesen Beitrag löschen möchtest?",
      delete: "Löschen",
      reply: "Antworten",
      loadingComments: "Kommentare werden geladen...",
      replyingTo: "Antworten auf",
      submitComment: "Kommentieren",
      expired: "Abgelaufen",
      guestLockText: "🔒 Registrieren um zu sehen",
      anonymousUser: "Benutzer",
      unknownCategory: "Unbekannt",
      firstPostTitle: "Die Pinnwand wartet auf dich!",
      firstPostSubtitle: "Teile deinen ersten Post, um den Feed freizuschalten",
      firstPostDescription: "Poste ein Foto oder Video, um zu sehen, was die Community teilt, und nimm an zuk\u00fcnftigen Wettbewerben mit Preisen teil!",
      firstPostButton: "Erstelle deinen ersten Post"
    },

    bdsmRelationships: {
      creatingRelationship: "BDSM-Beziehung erstellen",
      youAs: "Du als",
      partnerAs: "Partner als",
      searchSelectUser: "Suche und wähle den Benutzer aus, an den du eine Beziehungsanfrage senden möchtest",
      him: "Er",
      her: "Sie",
      selectPartnerCombination: "Wähle aus, welcher Partner welche Rolle hat:",
      accept: "Akzeptieren",
      decline: "Ablehnen",
      pending: "Ausstehend",
      confirm: "Bestätigen",
      sending: "Wird gesendet..."
    }
  },

  pt: {
    nickname: {
      title: "Escolha seu nickname",
      subtitle: "Este será seu nome exibido no Kinkygram",
      placeholder: "Digite seu nickname",
      checking: "Verificando disponibilidade...",
      available: "Disponível",
      notAvailable: "Não disponível",
      error: "Erro na verificação",
      required: "Nickname é obrigatório",
      tooShort: "Nickname deve ter pelo menos 3 caracteres",
      tooLong: "Nickname não pode exceder 30 caracteres",
      infoTitle: "Nickname",
      infoDescription: "Seu nickname é único e te identifica na plataforma. Recomendamos não usar seu nome de usuário do Telegram, pois ele será visível para todos os usuários."
    },
    category: {
      title: "Selecione sua categoria",
      subtitle: "Escolha a categoria que melhor te representa",
      required: "Selecione uma categoria",
      categories: {
        COUPLE: "Casal",
        GENTLEMAN: "Cavalheiro",
        SINGLE_LADY: "Senhora",
        DOM: "Dom",
        SUB_M: "Sub (M)",
        SUB_F: "Sub (F)",
        SWITCH_M: "Switch (M)",
        SWITCH_F: "Switch (F)",
        GAY: "Gay",
        LESBIAN: "Lésbica",
        BISEXUAL_M: "Bissexual (M)",
        BISEXUAL_F: "Bissexual (F)",
        TRANSGENDER: "Transgênero",
        LOVER_M: "Aberto a aventuras extraconjugais",
        LOVER_F: "Aberta a aventuras extraconjugais"
      }
    },
    interests: {
      title: 'Quais categorias te interessam?',
      subtitle: 'Selecione as categorias de pessoas que você gostaria de conhecer',
      description: 'Seus interesses nos ajudam a mostrar perfis e eventos relevantes. Você sempre pode alterar essas preferências posteriormente nas configurações do seu perfil.'
    },
    age: {
      title: "Digite sua idade",
      subtitle: "Você deve ter pelo menos 18 anos",
      birthDate: "Sua data de nascimento",
      partnerBirthDate: "Data de nascimento do parceiro",
      partnerBirthDateOptional: "Data de nascimento do parceiro (opcional)",
      required: "Data de nascimento é obrigatória",
      minimumAge: "Você deve ter pelo menos 18 anos",
      invalidAge: "Digite uma idade válida",
      partnerMinimumAge: "Parceiro deve ter pelo menos 18 anos",
      birthDateHim: "Data de nascimento (Ele)",
      birthDateHer: "Data de nascimento (Ela)",
      yourBirthDate: "Sua data de nascimento",
      age: "Idade",
      years: "anos",
      partnerAge: "Idade do seu parceiro",
      importantInfo: "Informações importantes",
      ageRequiredInfo: "A idade é necessária para garantir que todos os usuários na plataforma sejam adultos. Também é usado em filtros de pesquisa para ajudar os usuários a encontrar pessoas compatíveis."
    },
    location: {
      title: "Onde você está localizado?",
      subtitle: "Selecione sua cidade para se conectar com pessoas próximas",
      placeholder: "Busque sua cidade...",
      required: "Selecione sua cidade",
      incomplete: "Selecione uma cidade da lista",
      invalid: "Selecione uma cidade válida",
      yourCity: "Sua cidade",
      searchPlaceholder: "Busque sua cidade...",
      selectedLocation: "Localização selecionada",
      searchDescription: "Busque e selecione sua cidade usando autocompletar",
      privacyTitle: "Privacidade e localização",
      privacyDescription: "Sua localização é usada apenas para ajudá-lo a encontrar pessoas perto de você. Nunca compartilhamos sua localização exata, apenas a cidade e distância aproximada de outros usuários.",
      address: 'Endereço',
      addressHelp: 'Endereço completo da localização (visível apenas para participantes confirmados)',
      coordinates: 'Coordenadas GPS (opcional)',
      coordinatesHelp: 'Coordenadas GPS separadas por vírgula (lat,lng). Se não fornecidas, o endereço será usado para o Google Maps.',
      addressVisibility: 'Quando mostrar o endereço',
      addressImmediately: 'Imediatamente',
      maxHours: 'Máx 24h',
      addressVisibilityHelp: 'O endereço será visível para os participantes confirmados esta quantidade de horas antes do evento',
      locationAddress: 'Endereço do Local',
      streetAddress: 'Endereço',
      openInGoogleMaps: 'Abrir no Google Maps',
      addressWillBeRevealed: 'O endereço será revelado em:',
      confirmedParticipantsOnly: 'Apenas participantes confirmados podem ver o endereço',
      now: 'Agora',
    },
    confirm: {
      title: "Confirme suas informações",
      subtitle: "Verifique se todos os detalhes estão corretos",
      nickname: "Nickname",
      category: "Categoria",
      age: "Idade",
      location: "Localização",
      partner: "Parceiro",
      years: "anos",
      incomplete: "Algumas informações estão faltando"
    },
    photoOnboarding: {
      welcome: "Bem-vindo ao Kinkygram!",
      subtitle: "Faça upload da sua primeira foto para completar seu perfil",
      uploadSuccess: "✅ Perfeito! Você fez upload da sua primeira foto.",
      photoManagement: "Gerenciamento de Fotos do Perfil",
      guidelinesTitle: "Diretrizes e Regras para Fotos",
      allowedContent: "Conteúdo Permitido",
      allowedErotic: "Fotos eróticas são bem-vindas — no trash, sem genitais",
      allowedFace: "Fotos do rosto não são obrigatórias. Quem escolhe mostrá-las está ciente de que serão visíveis em uma comunidade Kinky",
      allowedReal: "Mostre seu melhor lado! Escolha fotos que te representam",
      prohibitedContent: "Estritamente proibido:",
      prohibitedMinors: "Qualquer conteúdo envolvendo menores",
      prohibitedNonConsensual: "Conteúdo não consensual ou material de vingança",
      prohibitedViolence: "Violência extrema, atividades ilegais ou conteúdo de ódio",
      prohibitedFake: "Perfis falsos ou fotos roubadas de outras pessoas",
      prohibitedNonPersonal: "Fotos que não te representam (carros, paisagens, memes, etc.)",
      warningTitle: "Importante:",
      warningText: "Perfis que violarem essas diretrizes serão banidos permanentemente. Sua conta do Telegram não será reabilitada para acesso ao Kinkygram.",
      startUsingApp: "Começar a usar o app"
    },

    validations: {
      title: 'Validações',
      metInPerson: 'Met in person',
      playedTogether: 'Played together',
      builtRelationship: 'Built a relationship',
      validation1Title: 'Conhecemos pessoalmente',
      validation2Title: 'A situação esquentou',
      validation3Title: 'Relação de amizade',
      validation1Description: 'Esta validação confirma que você conheceu pessoalmente na vida real.',
      validation2Description: 'Esta validação confirma que a situação entre vocês se tornou íntima e quente.',
      validation3Description: 'Esta validação confirma que você construiu uma relação de amizade duradoura.',
      exchangeValidation: 'Trocar uma validação',
      sendValidation: 'Enviar Validação',
      pending: 'Pendente',
      confirmed: 'Confirmada',
      declined: 'Recusada',
      accept: 'Aceitar',
      decline: 'Recusar',
      remove: 'Remove',
      removeConfirm: 'Tem certeza de que deseja remover esta validação?',
      confirmSendValidation: 'Tem certeza de que deseja enviar esta validação?',
      confirmDeclineValidation: 'Tem certeza de que deseja recusar esta validação?',
      validationSentSuccess: 'Validação enviada com sucesso!',
      validationSendError: 'Erro ao enviar validação',
      noValidations: 'Sem validações',
      noValidationsDescription: 'As validações recebidas aparecerão aqui',
      validationsConfirmed: 'Validações confirmadas',
      sentByYou: 'Enviada por você',
      close: 'Close'
    },

    partnerLinking: {
      title: "Parceiro Vinculado",
      connected: "Conta vinculada!",
      connectedDescription: "Seu parceiro tem acesso ao perfil compartilhado",
      notConnectedDescription: "Digite o nome de usuário do Telegram do seu parceiro para gerenciar o perfil de casal juntos.",
      inputPlaceholder: "@usuário ou usuário",
      buttonConnect: "Vincular",
      buttonSaving: "Salvando...",
      helpText: "O parceiro com este nome de usuário poderá acessar o perfil compartilhado"
    },

    partnerModal: {
      title: "Adicionar Parceiro",
      titleReadOnly: "Vínculo do Parceiro",
      infoReadOnly: "Este casal vinculou a conta do Telegram do parceiro. Ambos os parceiros podem acessar e usar este perfil compartilhado. Seus nomes são usados para identificar quem está conversando.",
      infoReadOnlyNotConnected: "Este casal ainda não vinculou a conta do Telegram do parceiro. O recurso de vínculo de parceiro permite que ambos os membros compartilhem o acesso ao mesmo perfil.",
      info: "Vincule a conta do Telegram do seu parceiro para compartilhar este perfil. Uma vez vinculados, ambos poderão usar a mesma conta e seus nomes serão usados nos chats.",
      usernameLabel: "Nome de Usuário do Telegram do Parceiro",
      saving: "(salvando...)",
      usernamePlaceholder: "usuário",
      linkedStatus: "Conta do Parceiro Vinculada",
      linkedDescription: "Este casal vinculou com sucesso a conta do Telegram do parceiro. Ambos os parceiros compartilham acesso a este perfil.",
      namesLabel: "Nomes para Exibição no Chat",
      namesDescription: "Estes nomes serão mostrados quando você conversar com outros",
      firstPartnerPlaceholder: "Nome do primeiro parceiro",
      secondPartnerPlaceholder: "Nome do segundo parceiro",
      namesReadOnlyTitle: "Nomes Exibidos no Chat",
      namesReadOnlyDescription: "Ao conversar, os parceiros usam estes nomes para identificar quem está escrevendo",
      partnerLinked: "Parceiro vinculado",
      addPartner: "Adicionar Parceiro"
    },

    common: {
      continue: "Continuar",
      back: "Voltar",
      completeRegistration: "Completar Cadastro",
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      spots: "vagas",
      day: "dia",
      days: "dias",
      hours: "horas",
      minutes: "min",
      seconds: "seg",
      participants: "Participantes",
      close: "Fechar",
      confirmed: "Confirmado",
      showTicket: "Mostrar Ticket",
      validations: "Validações"
    },

    banned: {
      title: "Conta Banida",
      message: "Sua conta foi banida",
      reason: "Motivo:",
      defaultReason: "Violação das diretrizes da comunidade",
      permanentMessage: "Você desperdiçou uma oportunidade. Esta conta está bloqueada permanentemente.",
      supportInfo: "Se você acredita que isso é um erro, entre em contato com o suporte."
    },

    speedDates: {
      today: "Hoje",
      tomorrow: "Amanhã",
      dayAfterTomorrow: "Depois de amanhã",
      openTo: "Aberto a:"
    },

    chat: {
      requestTitle: "Solicitação de Chat",
      continueOnTelegram: "Ao aceitar, a conversa continuará no",
      privacyMessage: "Apenas seu nome de usuário do Telegram será visível, garantindo sua privacidade.",
      messageLabel: "Mensagem",
      messagePlaceholder: "Escreva uma mensagem...",
      decline: "Recusar",
      accept: "Aceitar",
      noChatsYet: "Nenhum chat ainda",
      noChatsDescription: "Suas solicitações de chat aparecerão aqui",
      typing: "está digitando..."
    },
    events: {
      participate: "Participar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      buyTicket: "Comprar Ingresso",
      deleteEvent: "Excluir Evento",
      deleting: "Excluindo...",
      editCity: "Editar Cidade",
      selectNewCity: "Selecione uma nova cidade para este evento",
      cityUpdated: "Cidade atualizada",
      eventCityChanged: "Cidade do evento alterada para",
      searchCity: "Procurar uma cidade...",
      editDateTime: "Editar Data e Hora",
      selectDateTimeClose: "Selecione data e hora, depois feche para salvar",
      selectEventDate: "Selecionar Data do Evento",
      selectStartTime: "Selecionar Hora de Início",
      notOpenToCategory: "Este evento não está aberto para sua categoria",
      confirmDelete: "Confirmar Exclusão",
      confirmDeleteMessage: "Tem certeza de que deseja excluir este evento? Esta ação é irreversível e todos os participantes perderão sua participação.",
      cancelButton: "Cancelar",
      deleteButton: "Excluir Evento",
      loading: "Carregando...",
      loadingOrganizer: "Carregando organizador...",
      immediately: "Imediatamente",
      additionalInfo: "Info adicional",
      additionalInfoOptional: "Info adicional (opcional)",
      ticketNumber: "Número do ingresso",
      participant: "Participante",
      category: "Categoria",
      date: "Data",
      time: "Hora",
      organizedBy: "Organizado por",
      participants: "Participantes",
      openTo: "Aberto para",
      dressCode: "Código de Vestimenta",
      description: "Descrição",
      edit: "Editar",
      save: "Salvar",
      close: "Fechar",
      title: "Título",
      location: "Local",
      price: "Preço",
      free: "Grátis",
      spotsLeft: "vagas disponíveis",
      soldOut: "Esgotado",
      unlimited: "Ilimitado",
      locationAddress: "Endereço do Local",
      addressVisibilityLabel: "O endereço será visível para participantes confirmados este número de horas antes do evento",
      hour: "hora",
      hours: "horas",
      addressPlaceholder: "Rua Exemplo 123, Cidade",
      additionalInfoPlaceholder: "Ex: Campainha 3º andar, interfone SILVA, estacionamento disponível...",
      additionalInfoVisibilityNote: "Estas informações só serão visíveis quando o endereço se tornar visível",
      ticketHoldersOnly: "Apenas titulares de ingressos podem ver o endereço",
      publicShare: "Compartilhamento Público",
      publicShareDescription: "Crie um link para compartilhar fora do Kinkygram",
      createPublicLinkDescription: "Crie um link público para compartilhar o evento no Telegram e outros canais. Os visitantes verão os detalhes do evento e os participantes com fotos borradas.",
      createShareLink: "Criar Link de Compartilhamento",
      views: "Visualizações",
      status: "Status",
      active: "Ativo",
      shareLink: "Link de Compartilhamento",
      expiresWhenEventEnds: "Expira automaticamente quando o evento termina",
      share: "Compartilhar",
      preview: "Visualizar",
      whatVisitorsSee: "O que os visitantes veem:",
      allEventDetails: "Todos os detalhes do evento",
      participantsByCategory: "Lista de participantes por categoria",
      blurredPhotos: "Fotos de perfil borradas para privacidade",
      realtimeSpots: "Vagas disponíveis atualizadas em tempo real",
      error: "Erro",
      loadingShareStatus: "Não foi possível carregar o status de compartilhamento",
      linkCreated: "Link criado!",
      linkCreatedDescription: "O link de compartilhamento foi gerado com sucesso",
      sharingDisabled: "Compartilhamento desativado",
      sharingDisabledDescription: "O link público não está mais acessível",
      linkCopied: "Link copiado!",
      linkCopiedDescription: "Cole onde quiser compartilhar",
      cannotCopyLink: "Não foi possível copiar o link",
      checkOutEvent: "Confira este evento no Kinkygram!"
    },

    notifications: {
      noRecentParticipations: "Nenhuma participação recente",
      recentParticipations: "Participações Recentes",
      willParticipateIn: "vai participar de",
      showingLatestParticipations: "Mostrando as últimas 10 participações",
      showingLatestActivities: "Mostrando as últimas 20 atividades",
      feedNotificationsWillAppear: "As notificações do seu feed aparecerão aqui",
      visitedYou: "visitou você",
      mentionedYou: "mencionou você",
      upvotedYourPost: "deu Up no seu post",
      commentedOnYourPost: "comentou no seu post:"
    },

    wall: {
      willAttendEvent: "vão participar do evento",
      andOthers: "e",
      andOthersPlural: "e",
      noContent: "Nenhum conteúdo",
      noContentDescription: "Seja o primeiro a compartilhar algo no Mural!",
      comments: "Comentários",
      addComment: "Adicionar um comentário...",
      noCommentsYet: "Nenhum comentário ainda",
      readMore: "Ler mais →",
      deleteConfirm: "Tem certeza de que deseja excluir esta publicação?",
      delete: "Excluir",
      reply: "Responder",
      loadingComments: "Carregando comentários...",
      replyingTo: "Respondendo a",
      submitComment: "Comentar",
      expired: "Expirado",
      guestLockText: "🔒 Registre-se para ver",
      anonymousUser: "Usuário",
      unknownCategory: "Desconhecido",
      firstPostTitle: "O Mural te espera!",
      firstPostSubtitle: "Compartilhe seu primeiro post para desbloquear o feed",
      firstPostDescription: "Publique uma foto ou v\u00eddeo para ver o que a comunidade compartilha e participar de futuros concursos com pr\u00eamios!",
      firstPostButton: "Crie seu primeiro post"
    },

    bdsmRelationships: {
      creatingRelationship: "Criando Relação BDSM",
      youAs: "Você como",
      partnerAs: "Parceiro como",
      searchSelectUser: "Procure e selecione o usuário para quem você quer enviar uma solicitação de relação",
      him: "Ele",
      her: "Ela",
      selectPartnerCombination: "Selecione qual parceiro tem qual papel:",
      accept: "Aceitar",
      decline: "Recusar",
      pending: "Pendente",
      confirm: "Confirmar",
      sending: "Enviando..."
    }
  },

  fr: {
    nickname: {
      title: "Choisissez votre pseudo",
      subtitle: "Ce sera votre nom affiché sur Kinkygram",
      placeholder: "Entrez votre pseudo",
      checking: "Vérification de la disponibilité...",
      available: "Disponible",
      notAvailable: "Non disponible",
      error: "Erreur lors de la vérification",
      required: "Le pseudo est obligatoire",
      tooShort: "Le pseudo doit avoir au moins 3 caractères",
      tooLong: "Le pseudo ne peut pas dépasser 30 caractères",
      infoTitle: "Nickname",
      infoDescription: "Votre pseudo est unique et vous identifie sur la plateforme. Nous vous recommandons de ne pas utiliser votre nom d'utilisateur Telegram car il sera visible par tous les utilisateurs."
    },
    category: {
      title: "Sélectionnez votre catégorie",
      subtitle: "Choisissez la catégorie qui vous représente le mieux",
      required: "Veuillez sélectionner une catégorie",
      categories: {
        COUPLE: "Couple",
        GENTLEMAN: "Gentleman",
        SINGLE_LADY: "Dame",
        DOM: "Dom",
        SUB_M: "Sub (H)",
        SUB_F: "Sub (F)",
        SWITCH_M: "Switch (H)",
        SWITCH_F: "Switch (F)",
        GAY: "Gay",
        LESBIAN: "Lesbienne",
        BISEXUAL_M: "Bisexuel (H)",
        BISEXUAL_F: "Bisexuelle (F)",
        TRANSGENDER: "Transgenre",
        LOVER_M: "Ouvert aux aventures extraconjugales",
        LOVER_F: "Ouverte aux aventures extraconjugales"
      }
    },
    interests: {
      title: 'Quelles catégories vous intéressent?',
      subtitle: 'Sélectionnez les catégories de personnes que vous souhaitez rencontrer',
      description: "Vos centres d'intérêt nous aident à vous montrer des profils et des événements pertinents. Vous pouvez toujours modifier ces préférences plus tard dans les paramètres de votre profil."
    },
    age: {
      title: "Entrez votre âge",
      subtitle: "Vous devez avoir au moins 18 ans",
      birthDate: "Votre date de naissance",
      partnerBirthDate: "Date de naissance du partenaire",
      partnerBirthDateOptional: "Date de naissance du partenaire (optionnel)",
      required: "La date de naissance est obligatoire",
      minimumAge: "Vous devez avoir au moins 18 ans",
      invalidAge: "Veuillez entrer un âge valide",
      partnerMinimumAge: "Le partenaire doit avoir au moins 18 ans",
      birthDateHim: "Date de naissance (Lui)",
      birthDateHer: "Date de naissance (Elle)",
      yourBirthDate: "Votre date de naissance",
      age: "Âge",
      years: "ans",
      partnerAge: "Âge de votre partenaire",
      importantInfo: "Informations importantes",
      ageRequiredInfo: "L'âge est requis pour s'assurer que tous les utilisateurs de la plateforme sont des adultes. Il est également utilisé dans les filtres de recherche pour aider les utilisateurs à trouver des personnes compatibles."
    },
    location: {
      title: "Où êtes-vous situé?",
      subtitle: "Sélectionnez votre ville pour vous connecter avec des personnes proches",
      placeholder: "Recherchez votre ville...",
      required: "Veuillez sélectionner votre ville",
      incomplete: "Veuillez sélectionner une ville de la liste",
      invalid: "Veuillez sélectionner une ville valide",
      yourCity: "Votre ville",
      searchPlaceholder: "Recherchez votre ville...",
      selectedLocation: "Emplacement sélectionné",
      searchDescription: "Recherchez et sélectionnez votre ville en utilisant l'autocomplétion",
      privacyTitle: "Confidentialité et localisation",
      privacyDescription: "Votre emplacement n'est utilisé que pour vous aider à trouver des personnes près de chez vous. Nous ne partageons jamais votre emplacement exact, seulement la ville et la distance approximative des autres utilisateurs.",
      address: 'Adresse',
      addressHelp: 'Adresse complète de la localisation (visible uniquement aux participants confirmés)',
      coordinates: 'Coordonnées GPS (optionnel)',
      coordinatesHelp: 'Coordonnées GPS séparées par une virgule (lat,lng). Si elles ne sont pas fournies, l\'adresse sera utilisée pour Google Maps.',
      addressVisibility: 'Quand afficher l\'adresse',
      addressImmediately: 'Immédiatement',
      maxHours: 'Max 24h',
      addressVisibilityHelp: 'L\'adresse sera visible aux participants confirmés ce nombre d\'heures avant l\'événement',
      locationAddress: 'Adresse du Lieu',
      streetAddress: 'Adresse',
      openInGoogleMaps: 'Ouvrir dans Google Maps',
      addressWillBeRevealed: 'L\'adresse sera révélée dans:',
      confirmedParticipantsOnly: 'Seuls les participants confirmés peuvent voir l\'adresse',
      now: 'Maintenant',
    },
    confirm: {
      title: "Confirmez vos informations",
      subtitle: "Veuillez vérifier que tous les détails sont corrects",
      nickname: "Pseudo",
      category: "Catégorie",
      age: "Âge",
      location: "Localisation",
      partner: "Partenaire",
      years: "ans",
      incomplete: "Certaines informations manquent"
    },
    photoOnboarding: {
      welcome: "Bienvenue sur Kinkygram !",
      subtitle: "Téléchargez votre première photo pour compléter votre profil",
      uploadSuccess: "✅ Parfait ! Vous avez téléchargé votre première photo.",
      photoManagement: "Gestion des Photos de Profil",
      guidelinesTitle: "Directives et Règles pour les Photos",
      allowedContent: "Contenu Autorisé",
      allowedErotic: "Les photos érotiques sont les bienvenues — no trash, pas de génitaux",
      allowedFace: "Les photos de visage ne sont pas obligatoires. Ceux qui choisissent de les montrer sont conscients qu'elles seront visibles dans une communauté Kinky",
      allowedReal: "Montrez votre meilleur côté ! Choisissez des photos qui vous représentent",
      prohibitedContent: "Strictement interdit :",
      prohibitedMinors: "Tout contenu impliquant des mineurs",
      prohibitedNonConsensual: "Contenu non consensuel ou matériel de vengeance",
      prohibitedViolence: "Violence extrême, activités illégales ou contenu haineux",
      prohibitedFake: "Faux profils ou photos volées d'autres personnes",
      prohibitedNonPersonal: "Photos qui ne vous représentent pas (voitures, paysages, mèmes, dessins animés, etc.)",
      warningTitle: "Important :",
      warningText: "Les profils violant ces directives seront bannis définitivement. Votre compte Telegram ne sera pas réactivé pour l'accès à Kinkygram.",
      startUsingApp: "Commencer à utiliser l'app"
    },

    validations: {
      title: 'Validations',
      metInPerson: 'Met in person',
      playedTogether: 'Played together',
      builtRelationship: 'Built a relationship',
      validation1Title: 'Nous nous connaissons !',
      validation2Title: 'La situation est devenue chaude',
      validation3Title: 'Relation d\'amitié',
      validation1Description: 'Cette validation confirme que vous vous êtes rencontrés en personne dans la vie réelle.',
      validation2Description: 'Cette validation confirme que la situation entre vous est devenue intime et excitante.',
      validation3Description: 'Cette validation confirme que vous avez construit une relation amicale durable.',
      exchangeValidation: 'Échanger une validation',
      sendValidation: 'Envoyer une Validation',
      pending: 'En attente',
      confirmed: 'Confirmée',
      declined: 'Refusée',
      accept: 'Accepter',
      decline: 'Refuser',
      remove: 'Remove',
      removeConfirm: 'Êtes-vous sûr de vouloir supprimer cette validation ?',
      confirmSendValidation: 'Êtes-vous sûr de vouloir envoyer cette validation ?',
      confirmDeclineValidation: 'Êtes-vous sûr de vouloir refuser cette validation ?',
      validationSentSuccess: 'Validation envoyée avec succès!',
      validationSendError: 'Erreur lors de l\'envoi de la validation',
      noValidations: 'Aucune validation',
      noValidationsDescription: 'Les validations reçues apparaîtront ici',
      validationsConfirmed: 'Validations confirmées',
      sentByYou: 'Envoyée par vous',
      close: 'Close'
    },

    partnerLinking: {
      title: "Partenaire Lié",
      connected: "Compte lié !",
      connectedDescription: "Votre partenaire a accès au profil partagé",
      notConnectedDescription: "Entrez le nom d'utilisateur Telegram de votre partenaire pour gérer ensemble le profil de couple.",
      inputPlaceholder: "@nomutilisateur ou nomutilisateur",
      buttonConnect: "Lier",
      buttonSaving: "Enregistrement...",
      helpText: "Le partenaire avec ce nom d'utilisateur pourra accéder au profil partagé"
    },

    partnerModal: {
      title: "Ajouter un Partenaire",
      titleReadOnly: "Lien du Partenaire",
      infoReadOnly: "Ce couple a lié le compte Telegram du partenaire. Les deux partenaires peuvent accéder et utiliser ce profil partagé. Leurs noms sont utilisés pour identifier qui discute.",
      infoReadOnlyNotConnected: "Ce couple n'a pas encore lié le compte Telegram du partenaire. La fonctionnalité de lien de partenaire permet aux deux membres de partager l'accès au même profil.",
      info: "Liez le compte Telegram de votre partenaire pour partager ce profil. Une fois liés, vous pourrez tous les deux utiliser le même compte et vos noms seront utilisés dans les chats.",
      usernameLabel: "Nom d'utilisateur Telegram du Partenaire",
      saving: "(enregistrement...)",
      usernamePlaceholder: "nomutilisateur",
      linkedStatus: "Compte Partenaire Lié",
      linkedDescription: "Ce couple a lié avec succès le compte Telegram du partenaire. Les deux partenaires partagent l'accès à ce profil.",
      namesLabel: "Noms pour l'Affichage du Chat",
      namesDescription: "Ces noms seront affichés lorsque vous discutez avec d'autres",
      firstPartnerPlaceholder: "Nom du premier partenaire",
      secondPartnerPlaceholder: "Nom du deuxième partenaire",
      namesReadOnlyTitle: "Noms Affichés dans le Chat",
      namesReadOnlyDescription: "Lors des discussions, les partenaires utilisent ces noms pour identifier qui écrit",
      partnerLinked: "Partenaire lié",
      addPartner: "Ajouter un Partenaire"
    },

    common: {
      continue: "Continuer",
      back: "Retour",
      completeRegistration: "Terminer l'inscription",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      spots: "places",
      day: "jour",
      days: "jours",
      hours: "heures",
      minutes: "min",
      seconds: "sec",
      participants: "Participants",
      close: "Fermer",
      confirmed: "Confirmé",
      showTicket: "Afficher le Ticket",
      validations: "Validations"
    },

    banned: {
      title: "Compte Banné",
      message: "Votre compte a été banni",
      reason: "Raison:",
      defaultReason: "Violation des directives de la communauté",
      permanentMessage: "Vous avez gâché une opportunité. Ce compte est bloqué définitivement.",
      supportInfo: "Si vous pensez qu'il s'agit d'une erreur, contactez le support."
    },

    speedDates: {
      today: "Aujourd'hui",
      tomorrow: "Demain",
      dayAfterTomorrow: "Après-demain",
      openTo: "Ouvert à:"
    },

    chat: {
      requestTitle: "Demande de Chat",
      continueOnTelegram: "En acceptant, la conversation se poursuivra sur",
      privacyMessage: "Seul votre nom d'utilisateur Telegram sera visible, garantissant votre vie privée.",
      messageLabel: "Message",
      messagePlaceholder: "Écrivez un message...",
      decline: "Refuser",
      accept: "Accepter",
      noChatsYet: "Pas encore de chats",
      noChatsDescription: "Vos demandes de chat apparaîtront ici",
      typing: "est en train d'écrire..."
    },
    events: {
      participate: "Participer",
      cancel: "Annuler",
      confirm: "Confirmer",
      buyTicket: "Acheter Billet",
      deleteEvent: "Supprimer Événement",
      deleting: "Suppression...",
      editCity: "Modifier Ville",
      selectNewCity: "Sélectionnez une nouvelle ville pour cet événement",
      cityUpdated: "Ville mise à jour",
      eventCityChanged: "Ville de l'événement changée en",
      searchCity: "Rechercher une ville...",
      editDateTime: "Modifier Date et Heure",
      selectDateTimeClose: "Sélectionnez date et heure, puis fermez pour sauvegarder",
      selectEventDate: "Sélectionner Date de l'Événement",
      selectStartTime: "Sélectionner Heure de Début",
      notOpenToCategory: "Cet événement n'est pas ouvert à votre catégorie",
      confirmDelete: "Confirmer Suppression",
      confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer cet événement ? Cette action est irréversible et tous les participants perdront leur participation.",
      cancelButton: "Annuler",
      deleteButton: "Supprimer Événement",
      loading: "Chargement...",
      loadingOrganizer: "Chargement organisateur...",
      immediately: "Immédiatement",
      additionalInfo: "Info supplémentaire",
      additionalInfoOptional: "Info supplémentaire (optionnel)",
      ticketNumber: "Numéro de billet",
      participant: "Participant",
      category: "Catégorie",
      date: "Date",
      time: "Heure",
      organizedBy: "Organisé par",
      participants: "Participants",
      openTo: "Ouvert à",
      dressCode: "Code Vestimentaire",
      description: "Description",
      edit: "Modifier",
      save: "Sauvegarder",
      close: "Fermer",
      title: "Titre",
      location: "Lieu",
      price: "Prix",
      free: "Gratuit",
      spotsLeft: "places disponibles",
      soldOut: "Complet",
      unlimited: "Illimité",
      locationAddress: "Adresse du Lieu",
      addressVisibilityLabel: "L'adresse sera visible pour les participants confirmés ce nombre d'heures avant l'événement",
      hour: "heure",
      hours: "heures",
      addressPlaceholder: "123 Rue Exemple, Ville",
      additionalInfoPlaceholder: "Ex: Sonnette 3ème étage, interphone DUPONT, parking disponible...",
      additionalInfoVisibilityNote: "Ces informations ne seront visibles que lorsque l'adresse deviendra visible",
      ticketHoldersOnly: "Seuls les détenteurs de billets peuvent voir l'adresse",
      publicShare: "Partage Public",
      publicShareDescription: "Créez un lien à partager en dehors de Kinkygram",
      createPublicLinkDescription: "Créez un lien public pour partager l'événement sur Telegram et d'autres canaux. Les visiteurs verront les détails de l'événement et les participants avec des photos floues.",
      createShareLink: "Créer un Lien de Partage",
      views: "Vues",
      status: "Statut",
      active: "Actif",
      shareLink: "Lien de Partage",
      expiresWhenEventEnds: "Expire automatiquement à la fin de l'événement",
      share: "Partager",
      preview: "Aperçu",
      whatVisitorsSee: "Ce que voient les visiteurs :",
      allEventDetails: "Tous les détails de l'événement",
      participantsByCategory: "Liste des participants par catégorie",
      blurredPhotos: "Photos de profil floues pour la confidentialité",
      realtimeSpots: "Places disponibles mises à jour en temps réel",
      error: "Erreur",
      loadingShareStatus: "Impossible de charger le statut de partage",
      linkCreated: "Lien créé !",
      linkCreatedDescription: "Le lien de partage a été généré avec succès",
      sharingDisabled: "Partage désactivé",
      sharingDisabledDescription: "Le lien public n'est plus accessible",
      linkCopied: "Lien copié !",
      linkCopiedDescription: "Collez-le où vous voulez le partager",
      cannotCopyLink: "Impossible de copier le lien",
      checkOutEvent: "Découvrez cet événement sur Kinkygram !"
    },

    notifications: {
      noRecentParticipations: "Aucune participation récente",
      recentParticipations: "Participations Récentes",
      willParticipateIn: "participera à",
      showingLatestParticipations: "Affichage des 10 dernières participations",
      showingLatestActivities: "Affichage des 20 dernières activités",
      feedNotificationsWillAppear: "Les notifications de votre fil apparaîtront ici",
      visitedYou: "vous a visité",
      mentionedYou: "vous a mentionné",
      upvotedYourPost: "a aimé votre publication",
      commentedOnYourPost: "a commenté votre publication:"
    },

    wall: {
      willAttendEvent: "participeront à l'événement",
      andOthers: "et",
      andOthersPlural: "et",
      noContent: "Aucun contenu",
      noContentDescription: "Soyez le premier à partager quelque chose sur le Mur!",
      comments: "Commentaires",
      addComment: "Ajouter un commentaire...",
      noCommentsYet: "Pas encore de commentaires",
      readMore: "Lire la suite →",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer cette publication?",
      delete: "Supprimer",
      firstPostTitle: "Le Mur vous attend !",
      firstPostSubtitle: "Partagez votre premier post pour d\u00e9bloquer le fil",
      firstPostDescription: "Publiez une photo ou une vid\u00e9o pour voir ce que la communaut\u00e9 partage et participer \u00e0 de futurs concours avec des prix !",
      firstPostButton: "Cr\u00e9ez votre premier post"
    },

    bdsmRelationships: {
      creatingRelationship: "Création de Relation BDSM",
      youAs: "Vous en tant que",
      partnerAs: "Partenaire en tant que",
      searchSelectUser: "Recherchez et sélectionnez l'utilisateur à qui vous souhaitez envoyer une demande de relation",
      him: "Lui",
      her: "Elle",
      selectPartnerCombination: "Sélectionnez quel partenaire a quel rôle:",
      accept: "Accepter",
      decline: "Refuser",
      pending: "En attente",
      confirm: "Confirmer",
      sending: "Envoi..."
    }
  }
};

export function getTranslations(language: string): Translations {
  return translations[language] || translations.en;
}